import { Pokemon } from "../components/FactoryTypes";

export const rentalPokemon: Pokemon[] = [
  {
    type: "Flying Rock",
    style: "0 0 0 0",
    species: "Aerodactyl",
    set: "1",
    nature: "Adamant",
    item: "King's Rock",
    move1: "Ancient Power",
    move2: "Dragon Breath",
    move3: "Aerial Ace",
    move4: "Roar",
    abilities: "Rock Head / Pressure",
    evs: "170/170/ 0 / 0 / 0 /170",
    speed: "171",
  },
  {
    type: "Flying Rock",
    style: "4 0 0 0",
    species: "Aerodactyl",
    set: "2",
    nature: "Adamant",
    item: "Choice Band",
    move1: "Hyper Beam",
    move2: "Earthquake",
    move3: "Aerial Ace",
    move4: "Ancient Power",
    abilities: "Rock Head / Pressure",
    evs: "170/170/ 0 / 0 / 0 /170",
    speed: "171",
  },
  {
    type: "Flying Rock",
    style: "4 0 0 0",
    species: "Aerodactyl",
    set: "3",
    nature: "Hardy",
    item: "King's Rock",
    move1: "Double-Edge",
    move2: "Rock Slide",
    move3: "Fire Blast",
    move4: "Dragon Claw",
    abilities: "Rock Head / Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "150",
  },
  {
    type: "Rock Flying",
    style: "4 0 0 0 ",
    species: "Aerodactyl",
    set: "4",
    nature: "Hardy",
    item: "King's Rock",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Fire Blast",
    move4: "Bite",
    abilities: "Rock Head / Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "150",
  },
  {
    type: "Rock Steel",
    style: "0 0 0 0",
    species: "Aggron",
    set: "1",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Iron Tail",
    move2: "Earthquake",
    move3: "Aerial Ace",
    move4: "Roar",
    abilities: "Sturdy / Rock Head",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Rock Steel",
    style: "4 0 0 2",
    species: "Aggron",
    set: "2",
    nature: "Adamant",
    item: "Scope Lens",
    move1: "Focus Punch",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Thunder Wave",
    abilities: "Sturdy / Rock Head",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Rock Steel",
    style: "0 0 0 0",
    species: "Aggron",
    set: "3",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Surf",
    move2: "Thunder",
    move3: "Fire Blast",
    move4: "Blizzard",
    abilities: "Sturdy / Rock Head",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "70",
  },
  {
    type: "Rock Steel",
    style: "4 0 0 0",
    species: "Aggron",
    set: "4",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Aerial Ace",
    abilities: "Sturdy / Rock Head",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Psychic",
    style: "0 0 0 2",
    species: "Alakazam",
    set: "1",
    nature: "Modest",
    item: "Focus Band",
    move1: "Thunder Punch",
    move2: "Fire Punch",
    move3: "Ice Punch",
    move4: "Thunder Wave",
    abilities: "Synchronize / Inner Focus",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "140",
  },
  {
    type: "Psychic",
    style: "0 1 2 3",
    species: "Alakazam",
    set: "2",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Calm Mind",
    move3: "Thunder Wave",
    move4: "Recover",
    abilities: "Synchronize / Inner Focus",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "140",
  },
  {
    type: "Psychic",
    style: "6 2 0 6",
    species: "Alakazam",
    set: "3",
    nature: "Modest",
    item: "Choice Band",
    move1: "Trick",
    move2: "Disable",
    move3: "Psychic",
    move4: "Skill Swap",
    abilities: "Synchronize / Inner Focus",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "140",
  },
  {
    type: "Psychic",
    style: "0 0 0 0",
    species: "Alakazam",
    set: "4",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Thunder Punch",
    move3: "Fire Punch",
    move4: "Ice Punch",
    abilities: "Synchronize / Inner Focus",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "140",
  },
  {
    type: "Dragon Flying",
    style: "0 0 3 0",
    species: "Altaria",
    set: "1",
    nature: "Docile",
    item: "Cheri Berry",
    move1: "Dragon Claw",
    move2: "Aerial Ace",
    move3: "Refresh",
    move4: "Body Slam",
    abilities: "Natural Cure",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "100",
  },
  {
    type: "Dragon Flying",
    style: "4 0 0 2",
    species: "Altaria",
    set: "2",
    nature: "Bold",
    item: "Leftovers",
    move1: "Perish Song",
    move2: "Dragon Breath",
    move3: "Pursuit",
    move4: "Attract",
    abilities: "Natural Cure",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "100",
  },
  {
    type: "Dragon Flying",
    style: "2 1 0 0",
    species: "Altaria",
    set: "3",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Sing",
    move2: "Dragon Dance",
    move3: "Earthquake",
    move4: "Aerial Ace",
    abilities: "Natural Cure",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "100",
  },
  {
    type: "Dragon Flying",
    style: "0 0 0 0",
    species: "Altaria",
    set: "4",
    nature: "Docile",
    item: "Shell Bell",
    move1: "Dragon Claw",
    move2: "Earthquake",
    move3: "Flamethrower",
    move4: "Ice Beam",
    abilities: "Natural Cure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Electric",
    style: "0 7 2 2",
    species: "Ampharos",
    set: "1",
    nature: "Relaxed",
    item: "Magnet",
    move1: "Thunder",
    move2: "Rain Dance",
    move3: "Thunder Wave",
    move4: "Attract",
    abilities: "Static",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "67",
  },
  {
    type: "Electric",
    style: "0 0 0 2",
    species: "Ampharos",
    set: "2",
    nature: "Hardy",
    item: "Bright Powder",
    move1: "Thunder Punch",
    move2: "Fire Punch",
    move3: "Focus Punch",
    move4: "Thunder Wave",
    abilities: "Static",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "75",
  },
  {
    type: "Electric",
    style: "0 0 0 0",
    species: "Ampharos",
    set: "3",
    nature: "Hardy",
    item: "Focus Band",
    move1: "Thunderbolt",
    move2: "Mega Kick",
    move3: "Iron Tail",
    move4: "Brick Break",
    abilities: "Static",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "75",
  },
  {
    type: "Electric",
    style: "0 0 2 3",
    species: "Ampharos",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Thunderbolt",
    move2: "Fire Punch",
    move3: "Thunder Wave",
    move4: "Reflect",
    abilities: "Static",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "75",
  },
  {
    type: "Fire",
    style: "0 0 0 0",
    species: "Arcanine",
    set: "1",
    nature: "Adamant",
    item: "King's Rock",
    move1: "Flamethrower",
    move2: "Extreme Speed",
    move3: "Crunch",
    move4: "Body Slam",
    abilities: "Intimidate / Flash Fire",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "147",
  },
  {
    type: "Fire",
    style: "0 7 0 0",
    species: "Arcanine",
    set: "2",
    nature: "Docile",
    item: "Lum Berry",
    move1: "Fire Blast",
    move2: "Sunny Day",
    move3: "Crunch",
    move4: "Roar",
    abilities: "Intimidate / Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "147",
  },
  {
    type: "Fire ",
    style: "4 0 0 0",
    species: "Arcanine",
    set: "3",
    nature: "Modest",
    item: "White Herb",
    move1: "Overheat",
    move2: "Extreme Speed",
    move3: "Crunch",
    move4: "Aerial Ace",
    abilities: "Intimidate / Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "147",
  },
  {
    type: "Fire",
    style: "4 0 0 4",
    species: "Arcanine",
    set: "4",
    nature: "Docile",
    item: "White Herb",
    move1: "Overheat",
    move2: "Extreme Speed",
    move3: "Crunch",
    move4: "Double-Edge",
    abilities: "Intimidate / Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "147",
  },
  {
    type: "Bug Rock",
    style: "0 0 0 3",
    species: "Armaldo",
    set: "1",
    nature: "Adamant",
    item: "Scope Lens",
    move1: "Slash",
    move2: "Aerial Ace",
    move3: "Ancient Power",
    move4: "Protect",
    abilities: "Battle Armor",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "65",
  },
  {
    type: "Bug Rock",
    style: "0 0 0 5",
    species: "Armaldo",
    set: "2",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Iron Tail",
    move2: "Ancient Power",
    move3: "Brick Break",
    move4: "Knock Off",
    abilities: "Battle Armor",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "65",
  },
  {
    type: "Bug Rock",
    style: "0 0 0 1",
    species: "Armaldo",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Brick Break",
    move4: "Swords Dance",
    abilities: "Battle Armor",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "65",
  },
  {
    type: "Bug Rock",
    style: "4 0 0 0",
    species: "Armaldo",
    set: "4",
    nature: "Adamant",
    item: "Choice Band",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Aerial Ace",
    move4: "Rock Slide",
    abilities: "Battle Armor",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "65",
  },
  {
    type: "Ice Flying",
    style: "0 0 0 0",
    species: "Articuno",
    set: "1",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Ice Beam",
    move2: "Water Pulse",
    move3: "Icy Wind",
    move4: "Roar",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "137",
  },
  {
    type: "Ice Flying",
    style: "6 2 0 1",
    species: "Articuno",
    set: "2",
    nature: "Impish",
    item: "Leftovers",
    move1: "Substitute",
    move2: "Toxic",
    move3: "Blizzard",
    move4: "Double Team",
    abilities: "Pressure",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "105",
  },
  {
    type: "Ice Flying",
    style: "0 4 0 3",
    species: "Articuno",
    set: "3",
    nature: "Docile",
    item: "Bright Powder",
    move1: "Ice Beam",
    move2: "Facade",
    move3: "Aerial Ace",
    move4: "Protect",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ice Flying",
    style: "0 4 3 3",
    species: "Articuno",
    set: "4",
    nature: "Docile",
    item: "Chesto Berry",
    move1: "Blizzard",
    move2: "Double-Edge",
    move3: "Rest",
    move4: "Reflect",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ice Flying",
    style: "0 4 1 2",
    species: "Articuno",
    set: "5",
    nature: "Docile",
    item: "Focus Band",
    move1: "Blizzard",
    move2: "Double-Edge",
    move3: "Agility",
    move4: "Swagger",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ice Flying",
    style: "0 0 3 3 ",
    species: "Articuno",
    set: "6",
    nature: "Docile",
    item: "Chesto Berry",
    move1: "Ice Beam",
    move2: "Aerial Ace",
    move3: "Reflect",
    move4: "Rest",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Water",
    style: "0 7 0 0",
    species: "Blastoise",
    set: "1",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Hydro Pump",
    move2: "Rain Dance",
    move3: "Bite",
    move4: "Seismic Toss",
    abilities: "Torrent",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "98",
  },
  {
    type: "Water",
    style: "0 0 0 4",
    species: "Blastoise",
    set: "2",
    nature: "Brave",
    item: "Shell Bell",
    move1: "Hydro Pump",
    move2: "Mega Kick",
    move3: "Brick Break",
    move4: "Mirror Coat",
    abilities: "Torrent",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "88",
  },
  {
    type: "Water",
    style: "0 0 0 4",
    species: "Blastoise",
    set: "3",
    nature: "Docile",
    item: "Focus Band",
    move1: "Surf",
    move2: "Earthquake",
    move3: "Ice Beam",
    move4: "Counter",
    abilities: "Torrent",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "98",
  },
  {
    type: "Water",
    style: "0 0 0 4",
    species: "Blastoise",
    set: "4",
    nature: "Docile",
    item: "Focus Band",
    move1: "Surf",
    move2: "Earthquake",
    move3: "Ice Beam",
    move4: "Mirror Coat",
    abilities: "Torrent",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "98",
  },
  {
    type: "Fire Fighting",
    style: "0 7 0 0",
    species: "Blaziken",
    set: "1",
    nature: "Docile",
    item: "Quick Claw",
    move1: "Flamethrower",
    move2: "Sunny Day",
    move3: "Double Kick",
    move4: "Roar",
    abilities: "Blaze",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Fire Fighting",
    style: "0 0 0 0",
    species: "Blaziken",
    set: "2",
    nature: "Docile",
    item: "Scope Lens",
    move1: "Blaze Kick",
    move2: "Mega Kick",
    move3: "Thunder Punch",
    move4: "Brick Break",
    abilities: "Blaze",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Fire Fighting",
    style: "4 0 3 4",
    species: "Blaziken",
    set: "3",
    nature: "Hardy",
    item: "Salac Berry",
    move1: "Overheat",
    move2: "Earthquake",
    move3: "Endure",
    move4: "Reversal",
    abilities: "Blaze",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "132",
  },
  {
    type: "Fire Fighting",
    style: "4 0 0 0",
    species: "Blaziken",
    set: "4",
    nature: "Hardy",
    item: "White Herb",
    move1: "Overheat",
    move2: "Earthquake",
    move3: "Thunder Punch",
    move4: "Rock Slide",
    abilities: "Blaze",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Normal",
    style: "2 1 2 3",
    species: "Blissey",
    set: "1",
    nature: "Bold",
    item: "Bright Powder",
    move1: "Toxic",
    move2: "Double Team",
    move3: "Sing",
    move4: "Softboiled",
    abilities: "Natural Cure / Serene Grace",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "0 2 2 6",
    species: "Blissey",
    set: "2",
    nature: "Bold",
    item: "Leftovers",
    move1: "Seismic Toss",
    move2: "Sing",
    move3: "Attract",
    move4: "Substitute",
    abilities: "Natural Cure / Serene Grace",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "0 0 1 3",
    species: "Blissey",
    set: "3",
    nature: "Bold",
    item: "Focus Band",
    move1: "Fire Blast",
    move2: "Blizzard",
    move3: "Calm Mind",
    move4: "Softboiled",
    abilities: "Natural Cure / Serene Grace",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "0 1 4 3",
    species: "Blissey",
    set: "4",
    nature: "Bold",
    item: "Focus Band",
    move1: "Ice Beam",
    move2: "Calm Mind",
    move3: "Counter",
    move4: "Softboiled",
    abilities: "Natural Cure / Serene Grace",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "75",
  },
  {
    type: "Grass Fighting",
    style: "0 0 0 4",
    species: "Breloom",
    set: "1",
    nature: "Jolly",
    item: "King's Rock",
    move1: "Sky Uppercut",
    move2: "Mach Punch",
    move3: "Headbutt",
    move4: "Counter",
    abilities: "Effect Spore",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "134",
  },
  {
    type: "Grass Fighting",
    style: "0 2 4 2",
    species: "Breloom",
    set: "2",
    nature: "Docile",
    item: "Bright Powder",
    move1: "Giga Drain",
    move2: "Leech Seed",
    move3: "Focus Punch",
    move4: "Spore",
    abilities: "Effect Spore",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "122",
  },
  {
    type: "Grass Fighting",
    style: "0 4 2 2",
    species: "Breloom",
    set: "3",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Iron Tail",
    move2: "Focus Punch",
    move3: "Attract",
    move4: "Spore",
    abilities: "Effect Spore",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "122",
  },
  {
    type: "Grass Fighting",
    style: "4 0 2 1",
    species: "Breloom",
    set: "4",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Focus Punch",
    move2: "Sludge Bomb",
    move3: "Spore",
    move4: "Double Team",
    abilities: "Effect Spore",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "122",
  },
  {
    type: "Flying Fire",
    style: "0 7 0 5",
    species: "Charizard",
    set: "1",
    nature: "Modest",
    item: "Focus Band",
    move1: "Fire Blast",
    move2: "Sunny Day",
    move3: "Roar",
    move4: "Scary Face",
    abilities: "Blaze",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Fire Flying",
    style: "0 0 1 5",
    species: "Charizard",
    set: "2",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Earthquake",
    move2: "Aerial Ace",
    move3: "Dragon Dance",
    move4: "SmokeScreen",
    abilities: "Blaze",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Fire Flying",
    style: "0 0 0 0",
    species: "Charizard",
    set: "3",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Flamethrower",
    move2: "Dragon Claw",
    move3: "Bite",
    move4: "Brick Break",
    abilities: "Blaze",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Fire Flying",
    style: "4 0 0 0",
    species: "Charizard",
    set: "4",
    nature: "Hardy",
    item: "White Herb",
    move1: "Overheat",
    move2: "Earthquake",
    move3: "Aerial Ace",
    move4: "Rock Slide",
    abilities: "Blaze",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "141",
  },
  {
    type: "Ground Psychic",
    style: "0 0 2 1",
    species: "Claydol",
    set: "1",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Swagger",
    move4: "Psych Up",
    abilities: "Levitate",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "95",
  },
  {
    type: "Ground Psychic",
    style: "0 0 1 1",
    species: "Claydol",
    set: "2",
    nature: "Calm",
    item: "Leftovers",
    move1: "Psychic",
    move2: "Earthquake",
    move3: "Double Team",
    move4: "Cosmic Power",
    abilities: "Levitate",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "95",
  },
  {
    type: "Ground Psychic",
    style: "0 0 0 7",
    species: "Claydol",
    set: "3",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Psychic",
    move2: "Ice Beam",
    move3: "SolarBeam",
    move4: "Sunny Day",
    abilities: "Levitate",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "95",
  },
  {
    type: "Ground Psychic",
    style: "0 0 0 4",
    species: "Claydol",
    set: "4",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Psychic",
    move2: "Earthquake",
    move3: "Shadow Ball",
    move4: "Explosion",
    abilities: "Levitate",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "95",
  },
  {
    type: "Normal",
    style: "6 1 3 6",
    species: "Clefable",
    set: "1",
    nature: "Brave",
    item: "Leftovers",
    move1: "Metronome",
    move2: "Double Team",
    move3: "Reflect",
    move4: "Follow Me",
    abilities: "Cute Charm",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "72",
  },
  {
    type: "Normal",
    style: "0 1 1 6",
    species: "Clefable",
    set: "2",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Meteor Mash",
    move2: "Cosmic Power",
    move3: "Double Team",
    move4: "Follow Me",
    abilities: "Cute Charm",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "80",
  },
  {
    type: "Normal",
    style: "0 0 0 0",
    species: "Clefable",
    set: "3",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Thunderbolt",
    move2: "Ice Beam",
    move3: "Flamethrower",
    move4: "Magical Leaf",
    abilities: "Cute Charm",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "80",
  },
  {
    type: "Normal",
    style: "0 0 0 3",
    species: "Clefable",
    set: "4",
    nature: "Docile",
    item: "Focus Band",
    move1: "Mega Kick",
    move2: "Psychic",
    move3: "Shadow Ball",
    move4: "Softboiled",
    abilities: "Cute Charm",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "80",
  },
  {
    type: "Grass",
    style: "0 0 1 2",
    species: "Cradily",
    set: "1",
    nature: "Relaxed",
    item: "Leftovers",
    move1: "Giga Drain",
    move2: "Rock Slide",
    move3: "Barrier",
    move4: "Confuse Ray",
    abilities: "Suction Cups",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "57",
  },
  {
    type: "Grass Rock",
    style: "0 0 2 1",
    species: "Cradily",
    set: "2",
    nature: "Adamant",
    item: "Sitrus Berry",
    move1: "Earthquake",
    move2: "Ancient Power",
    move3: "Swagger",
    move4: "Psych Up",
    abilities: "Suction Cups",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "63",
  },
  {
    type: "Grass Rock",
    style: "6 0 7 3",
    species: "Cradily",
    set: "3",
    nature: "Modest",
    item: "Leftovers",
    move1: "Substitute",
    move2: "SolarBeam",
    move3: "Sunny Day",
    move4: "Recover",
    abilities: "Suction Cups",
    evs: " 0 / 0 /170/170/170/ 0 ",
    speed: "63",
  },
  {
    type: "Grass Rock",
    style: "2 3 4 0",
    species: "Cradily",
    set: "4",
    nature: "Bold",
    item: "Leftovers",
    move1: "Toxic",
    move2: "Ingrain",
    move3: "Mirror Coat",
    move4: "Giga Drain",
    abilities: "Suction Cups",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "63",
  },
  {
    type: "Flying Poison",
    style: "0 0 0 5",
    species: "Crobat",
    set: "1",
    nature: "Quirky",
    item: "King's Rock",
    move1: "Sludge Bomb",
    move2: "Bite",
    move3: "Astonish",
    move4: "Screech",
    abilities: "Inner Focus",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "150",
  },
  {
    type: "Flying Poison",
    style: "2 0 2 1",
    species: "Crobat",
    set: "2",
    nature: "Calm",
    item: "Leftovers",
    move1: "Toxic",
    move2: "Giga Drain",
    move3: "Confuse Ray",
    move4: "Double Team",
    abilities: "Inner Focus",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "150",
  },
  {
    type: "Flying Poison",
    style: "0 4 0 5",
    species: "Crobat",
    set: "3",
    nature: "Adamant",
    item: "Scope Lens",
    move1: "Air Cutter",
    move2: "Double-Edge",
    move3: "Shadow Ball",
    move4: "Screech",
    abilities: "Inner Focus",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "182",
  },
  {
    type: "Flying Poison",
    style: "0 0 0 2",
    species: "Crobat",
    set: "4",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Sludge Bomb",
    move2: "Aerial Ace",
    move3: "Shadow Ball",
    move4: "Confuse Ray",
    abilities: "Inner Focus",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "182",
  },
  {
    type: "Ice Water",
    style: "0 0 0 0",
    species: "Dewgong",
    set: "1",
    nature: "Quiet",
    item: "NeverMeltIce",
    move1: "Ice Beam",
    move2: "Icy Wind",
    move3: "Headbutt",
    move4: "Fake Out",
    abilities: "Thick Fat",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "81",
  },
  {
    type: "Ice Water",
    style: "0 4 2 2",
    species: "Dewgong",
    set: "2",
    nature: "Docile",
    item: "Shell Bell",
    move1: "Blizzard",
    move2: "Double-Edge",
    move3: "Encore",
    move4: "Disable",
    abilities: "Thick Fat",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Ice Water",
    style: "4 0 0 3",
    species: "Dewgong",
    set: "3",
    nature: "Bold",
    item: "Chesto Berry",
    move1: "Horn Drill",
    move2: "Sheer Cold",
    move3: "Sleep Talk",
    move4: "Rest",
    abilities: "Thick Fat",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "90",
  },
  {
    type: "Ice Water",
    style: "0 0 0 0",
    species: "Dewgong",
    set: "4",
    nature: "Docile",
    item: "Lum Berry",
    move1: "Sheer Cold",
    move2: "Ice Beam",
    move3: "Surf",
    move4: "Signal Beam",
    abilities: "Thick Fat",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Normal Flying",
    style: "0 0 0 3",
    species: "Dodrio",
    set: "1",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Drill Peck",
    move2: "Tri Attack",
    move3: "Sleep Talk",
    move4: "Rest",
    abilities: "Run Away / Early Bird",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Normal Flying",
    style: "0 4 0 3",
    species: "Dodrio",
    set: "2",
    nature: "Adamant",
    item: "King's Rock",
    move1: "Drill Peck",
    move2: "Double-Edge",
    move3: "Faint Attack",
    move4: "Protect",
    abilities: "Run Away / Early Bird",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Normal Flying",
    style: "4 0 0 0",
    species: "Dodrio",
    set: "3",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Double-Edge",
    move2: "Drill Peck",
    move3: "Steel Wing",
    move4: "Faint Attack",
    abilities: "Run Away / Early Bird",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Normal Flying",
    style: "4 3 0 4",
    species: "Dodrio",
    set: "4",
    nature: "Adamant",
    item: "Salac Berry",
    move1: "Flail",
    move2: "Endure",
    move3: "Drill Peck",
    move4: "Facade",
    abilities: "Run Away / Early Bird",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Ground",
    style: "0 0 2 3",
    species: "Donphan",
    set: "1",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Earthquake",
    move2: "Ancient Power",
    move3: "Swagger",
    move4: "Rest",
    abilities: "Sturdy",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Ground",
    style: "4 3 0 0",
    species: "Donphan",
    set: "2",
    nature: "Jolly",
    item: "Quick Claw",
    move1: "Flail",
    move2: "Endure",
    move3: "Earthquake",
    move4: "Rock Tomb",
    abilities: "Sturdy",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "112",
  },
  {
    type: "Ground",
    style: "4 0 0 0",
    species: "Donphan",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Fissure",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Secret Power",
    abilities: "Sturdy",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Ground",
    style: "4 0 0 0",
    species: "Donphan",
    set: "4",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Fissure",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Iron Tail",
    abilities: "Sturdy",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Dragon Flying",
    style: "0 0 0 1",
    species: "Dragonite",
    set: "1",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Earthquake",
    move2: "Aerial Ace",
    move3: "Brick Break",
    move4: "Dragon Dance",
    abilities: "Inner Focus",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "100",
  },
  {
    type: "Dragon Flying",
    style: "0 4 0 1",
    species: "Dragonite",
    set: "2",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Earthquake",
    move2: "Double-Edge",
    move3: "Aerial Ace",
    move4: "Dragon Dance",
    abilities: "Inner Focus",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "100",
  },
  {
    type: "Dragon Flying",
    style: "4 2 1 2",
    species: "Dragonite",
    set: "3",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Hyper Beam",
    move2: "Attract",
    move3: "Double Team",
    move4: "Thunder Wave",
    abilities: "Inner Focus",
    evs: " 0 /170/170/ 0 /170/ 0 ",
    speed: "100",
  },
  {
    type: "Dragon Flying",
    style: "4 2 1 3",
    species: "Dragonite",
    set: "4",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Hyper Beam",
    move2: "Thunder Wave",
    move3: "Dragon Dance",
    move4: "Rest",
    abilities: "Inner Focus",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "100",
  },
  {
    type: "Dragon Flying",
    style: "0 4 2 0",
    species: "Dragonite",
    set: "5",
    nature: "Docile",
    item: "Lum Berry",
    move1: "Outrage",
    move2: "Double-Edge",
    move3: "Thunder Wave",
    move4: "Roar",
    abilities: "Inner Focus",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Dragon Flying",
    style: "0 0 0 0",
    species: "Dragonite",
    set: "6",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Dragon Claw",
    move2: "Thunderbolt",
    move3: "Surf",
    move4: "Flamethrower",
    abilities: "Inner Focus",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "132",
  },
  {
    type: "Dragon Flying",
    style: "0 0 0 0",
    species: "Dragonite",
    set: "7",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Dragon Claw",
    move2: "Thunderbolt",
    move3: "Surf",
    move4: "Ice Beam",
    abilities: "Inner Focus",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "132",
  },
  {
    type: "Dragon Flying",
    style: "0 0 0 0",
    species: "Dragonite",
    set: "8",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Dragon Claw",
    move2: "Flamethrower",
    move3: "Ice Beam",
    move4: "Brick Break",
    abilities: "Inner Focus",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "132",
  },
  {
    type: "Dragon Flying",
    style: "0 0 7 0",
    species: "Dragonite",
    set: "9",
    nature: "Docile",
    item: "Quick Claw",
    move1: "Thunder",
    move2: "Surf",
    move3: "Rain Dance",
    move4: "Earthquake",
    abilities: "Inner Focus",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Dragon Flying",
    style: "0 0 7 0",
    species: "Dragonite",
    set: "X",
    nature: "Docile",
    item: "Quick Claw",
    move1: "Fire Blast",
    move2: "Blizzard",
    move3: "Sunny Day",
    move4: "Earthquake",
    abilities: "Inner Focus",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Ground",
    style: "0 0 0 0",
    species: "Dugtrio",
    set: "1",
    nature: "Adamant",
    item: "Soft Sand",
    move1: "Earthquake",
    move2: "Tri Attack",
    move3: "Slash",
    move4: "Sand Tomb",
    abilities: "Sand Veil / Arena Trap",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "172",
  },
  {
    type: "Ground",
    style: "0 0 0 0",
    species: "Dugtrio",
    set: "2",
    nature: "Adamant",
    item: "King's Rock",
    move1: "Earthquake",
    move2: "Ancient Power",
    move3: "Aerial Ace",
    move4: "Tri Attack",
    abilities: "Sand Veil / Arena Trap",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "172",
  },
  {
    type: "Ground",
    style: "0 4 0 4",
    species: "Dugtrio",
    set: "3",
    nature: "Adamant",
    item: "King's Rock",
    move1: "Earthquake",
    move2: "Double-Edge",
    move3: "Sludge Bomb",
    move4: "Fissure",
    abilities: "Sand Veil / Arena Trap",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "172",
  },
  {
    type: "Ground ",
    style: "0 4 0 4",
    species: "Dugtrio",
    set: "4",
    nature: "Adamant",
    item: "King's Rock",
    move1: "Earthquake",
    move2: "Double-Edge",
    move3: "Rock Slide",
    move4: "Fissure",
    abilities: "Sand Veil / Arena Trap",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "172",
  },
  {
    type: "Ghost",
    style: "2 0 4 2",
    species: "Dusclops",
    set: "1",
    nature: "Impish",
    item: "Leftovers",
    move1: "Will-O-Wisp",
    move2: "Seismic Toss",
    move3: "Pain Split",
    move4: "Confuse Ray",
    abilities: "Pressure",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "45",
  },
  {
    type: "Ghost",
    style: "2 2 1 3",
    species: "Dusclops",
    set: "2",
    nature: "Impish",
    item: "Leftovers",
    move1: "Toxic",
    move2: "Confuse Ray",
    move3: "Double Team",
    move4: "Protect",
    abilities: "Pressure",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "45",
  },
  {
    type: "Ghost",
    style: "1 2 0 0",
    species: "Dusclops",
    set: "3",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Psych Up",
    move2: "Swagger",
    move3: "Shadow Ball",
    move4: "Earthquake",
    abilities: "Pressure",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "45",
  },
  {
    type: "Ghost",
    style: "4 0 6 3",
    species: "Dusclops",
    set: "4",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Double-Edge",
    move2: "Shadow Ball",
    move3: "Curse",
    move4: "Rest",
    abilities: "Pressure",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "45",
  },
  {
    type: "Electric",
    style: "0 2 0 3",
    species: "Electabuzz",
    set: "1",
    nature: "Relaxed",
    item: "Cheri Berry",
    move1: "Thunderbolt",
    move2: "Thunder Wave",
    move3: "Brick Break",
    move4: "Light Screen",
    abilities: "Static",
    evs: "170/ 0 /170/170/ 0 / 0 ",
    speed: "112",
  },
  {
    type: "Electric",
    style: "0 7 2 4",
    species: "Electabuzz",
    set: "2",
    nature: "Quirky",
    item: "Leftovers",
    move1: "Thunder",
    move2: "Rain Dance",
    move3: "Attract",
    move4: "Focus Punch",
    abilities: "Static",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "146",
  },
  {
    type: "Electric",
    style: "0 0 0 0",
    species: "Electabuzz",
    set: "3",
    nature: "Quirky",
    item: "Lum Berry",
    move1: "Fire Punch",
    move2: "Ice Punch",
    move3: "Thunderbolt",
    move4: "Cross Chop",
    abilities: "Static",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "157",
  },
  {
    type: "Electric",
    style: "0 0 0 0",
    species: "Electabuzz",
    set: "4",
    nature: "Docile",
    item: "Scope Lens",
    move1: "Thunderbolt",
    move2: "Psychic",
    move3: "Mega Kick",
    move4: "Cross Chop",
    abilities: "Static",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "125",
  },
  {
    type: "Electric",
    style: "0 0 3 3",
    species: "Electrode",
    set: "1",
    nature: "Quiet",
    item: "Focus Band",
    move1: "Thunderbolt",
    move2: "Swift",
    move3: "Light Screen",
    move4: "Protect",
    abilities: "Soundproof / Static",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "144",
  },
  {
    type: "Electric",
    style: "0 7 1 2",
    species: "Electrode",
    set: "2",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Thunder",
    move2: "Rain Dance",
    move3: "Double Team",
    move4: "Swagger",
    abilities: "Soundproof / Static",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "160",
  },
  {
    type: "Electric",
    style: "4 0 2 3",
    species: "Electrode",
    set: "3",
    nature: "Naughty",
    item: "Liechi Berry",
    move1: "Explosion",
    move2: "Thunderbolt",
    move3: "Thunder Wave",
    move4: "Endure",
    abilities: "Soundproof / Static",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "160",
  },
  {
    type: "Electric",
    style: "4 0 2 4",
    species: "Electrode",
    set: "4",
    nature: "Naughty",
    item: "Lum Berry",
    move1: "Explosion",
    move2: "Thunderbolt",
    move3: "Thunder Wave",
    move4: "Mirror Coat",
    abilities: "Soundproof / Static",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "160",
  },
  {
    type: "Fire",
    style: "0 1 1 3",
    species: "Entei",
    set: "1",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Flamethrower",
    move2: "Double Team",
    move3: "Calm Mind",
    move4: "Rest",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Fire",
    style: "0 7 0 3",
    species: "Entei",
    set: "2",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Fire Blast",
    move2: "Sunny Day",
    move3: "SolarBeam",
    move4: "Reflect",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Fire",
    style: "0 4 2 1",
    species: "Entei",
    set: "3",
    nature: "Docile",
    item: "Lum Berry",
    move1: "Flamethrower",
    move2: "Double-Edge",
    move3: "Swagger",
    move4: "Psych Up",
    abilities: "Pressure",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Fire",
    style: "0 0 1 3",
    species: "Entei",
    set: "4",
    nature: "Modest",
    item: "King's Rock",
    move1: "Flamethrower",
    move2: "Bite",
    move3: "Double Team",
    move4: "Reflect",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Fire",
    style: "0 4 3 3",
    species: "Entei",
    set: "5",
    nature: "Docile",
    item: "Salac Berry",
    move1: "Fire Blast",
    move2: "Double-Edge",
    move3: "Endure",
    move4: "Reflect",
    abilities: "Pressure",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "120",
  },
  {
    type: "Fire",
    style: "0 1 0 3",
    species: "Entei",
    set: "6",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Flamethrower",
    move2: "Calm Mind",
    move3: "Roar",
    move4: "Rest",
    abilities: "Pressure",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "120",
  },
  {
    type: "Psychic",
    style: "0 5 1 3",
    species: "Espeon",
    set: "1",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Charm",
    move3: "Calm Mind",
    move4: "Baton Pass",
    abilities: "Synchronize",
    evs: " 0 / 0 /170/ 0 /170/170",
    speed: "151",
  },
  {
    type: "Psychic",
    style: "0 0 1 3",
    species: "Espeon",
    set: "2",
    nature: "Docile",
    item: "Chesto Berry",
    move1: "Psychic",
    move2: "Shadow Ball",
    move3: "Calm Mind",
    move4: "Rest",
    abilities: "Synchronize",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "162",
  },
  {
    type: "Psychic",
    style: "0 0 3 3",
    species: "Espeon",
    set: "3",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Bite",
    move3: "Wish",
    move4: "Reflect",
    abilities: "Synchronize",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "162",
  },
  {
    type: "Psychic",
    style: "0 0 2 1",
    species: "Espeon",
    set: "4",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Bite",
    move3: "Attract",
    move4: "Calm Mind",
    abilities: "Synchronize",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "162",
  },
  {
    type: "Grass Psychic",
    style: "0 7 3 3",
    species: "Exeggutor",
    set: "1",
    nature: "Quiet",
    item: "Quick Claw",
    move1: "SolarBeam",
    move2: "Sunny Day",
    move3: "Synthesis",
    move4: "Light Screen",
    abilities: "Chlorophyll",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "67",
  },
  {
    type: "Grass Psychic",
    style: "0 6 2 3",
    species: "Exeggutor",
    set: "2",
    nature: "Hardy",
    item: "Chesto Berry",
    move1: "Return",
    move2: "Curse",
    move3: "Sleep Powder",
    move4: "Rest",
    abilities: "Chlorophyll",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "75",
  },
  {
    type: "Grass Psychic",
    style: "2 0 2 4",
    species: "Exeggutor",
    set: "3",
    nature: "Hardy",
    item: "Leftovers",
    move1: "Leech Seed",
    move2: "Giga Drain",
    move3: "Toxic",
    move4: "Explosion",
    abilities: "Chlorophyll",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "75",
  },
  {
    type: "Grass Psychic",
    style: "0 0 0 4",
    species: "Exeggutor",
    set: "4",
    nature: "Hardy",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Giga Drain",
    move3: "Sludge Bomb",
    move4: "Explosion",
    abilities: "Chlorophyll",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "0 0 0 3",
    species: "Exploud",
    set: "1",
    nature: "Impish",
    item: "Chesto Berry",
    move1: "Hyper Voice",
    move2: "Shadow Ball",
    move3: "Sleep Talk",
    move4: "Rest",
    abilities: "Soundproof",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "88",
  },
  {
    type: "Normal",
    style: "0 7 0 4",
    species: "Exploud",
    set: "2",
    nature: "Quirky",
    item: "Focus Band",
    move1: "SolarBeam",
    move2: "Sunny Day",
    move3: "Earthquake",
    move4: "Counter",
    abilities: "Soundproof",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "88",
  },
  {
    type: "Normal",
    style: "4 0 0 0",
    species: "Exploud",
    set: "3",
    nature: "Modest",
    item: "White Herb",
    move1: "Overheat",
    move2: "Ice Beam",
    move3: "Thunder Punch",
    move4: "Extrasensory",
    abilities: "Soundproof",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "120",
  },
  {
    type: "Normal",
    style: "0 0 0 4",
    species: "Exploud",
    set: "4",
    nature: "Hardy",
    item: "White Herb",
    move1: "Mega Kick",
    move2: "Earthquake",
    move3: "Shadow Ball",
    move4: "Overheat",
    abilities: "Soundproof",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "88",
  },
  {
    type: "Normal Flying",
    style: "0 0 4 0",
    species: "Fearow",
    set: "1",
    nature: "Adamant",
    item: "Sharp Beak",
    move1: "Drill Peck",
    move2: "Tri Attack",
    move3: "Facade",
    move4: "Mud-Slap",
    abilities: "Keen Eye",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Normal Flying",
    style: "0 0 2 0",
    species: "Fearow",
    set: "2",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Drill Peck",
    move2: "Tri Attack",
    move3: "Attract",
    move4: "Pursuit",
    abilities: "Keen Eye",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Normal Flying",
    style: "0 0 0 0",
    species: "Fearow",
    set: "3",
    nature: "Hardy",
    item: "Scope Lens",
    move1: "Drill Peck",
    move2: "Return",
    move3: "Steel Wing",
    move4: "Faint Attack",
    abilities: "Keen Eye",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Normal Flying",
    style: "0 4 0 4",
    species: "Fearow",
    set: "4",
    nature: "Hardy",
    item: "Lum Berry",
    move1: "Drill Peck",
    move2: "Double-Edge",
    move3: "Steel Wing",
    move4: "Sky Attack",
    abilities: "Keen Eye",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "120",
  },
  {
    type: "Water",
    style: "0 7 0 0",
    species: "Feraligatr",
    set: "1",
    nature: "Quiet",
    item: "Lum Berry",
    move1: "Surf",
    move2: "Rain Dance",
    move3: "Aerial Ace",
    move4: "Roar",
    abilities: "Torrent",
    evs: "170/ 0 / 0 /170/170/ 0 ",
    speed: "88",
  },
  {
    type: "Water",
    style: "0 0 0 5",
    species: "Feraligatr",
    set: "2",
    nature: "Sassy",
    item: "Quick Claw",
    move1: "Surf",
    move2: "Dragon Claw",
    move3: "Brick Break",
    move4: "Scary Face",
    abilities: "Torrent",
    evs: "170/ 0 / 0 /170/170/ 0 ",
    speed: "88",
  },
  {
    type: "Water",
    style: "0 0 0 0",
    species: "Feraligatr",
    set: "3",
    nature: "Hardy",
    item: "Scope Lens",
    move1: "Hydro Pump",
    move2: "Crunch",
    move3: "Earthquake",
    move4: "Rock Slide",
    abilities: "Torrent",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "98",
  },
  {
    type: "Water",
    style: "0 0 0 0",
    species: "Feraligatr",
    set: "4",
    nature: "Hardy",
    item: "Scope Lens",
    move1: "Hydro Pump",
    move2: "Ice Beam",
    move3: "Earthquake",
    move4: "Aerial Ace",
    abilities: "Torrent",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "98",
  },
  {
    type: "Fire",
    style: "0 0 0 5",
    species: "Flareon",
    set: "1",
    nature: "Modest",
    item: "Sitrus Berry",
    move1: "Flamethrower",
    move2: "Roar",
    move3: "Bite",
    move4: "Sand-Attack",
    abilities: "Flash Fire",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "85",
  },
  {
    type: "Fire",
    style: "6 2 4 0",
    species: "Flareon",
    set: "2",
    nature: "Relaxed",
    item: "Quick Claw",
    move1: "Curse",
    move2: "Attract",
    move3: "Double-Edge",
    move4: "Shadow Ball",
    abilities: "Flash Fire",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "76",
  },
  {
    type: "Fire",
    style: "0 4 3 4",
    species: "Flareon",
    set: "3",
    nature: "Jolly",
    item: "Quick Claw",
    move1: "Shadow Ball",
    move2: "Flail",
    move3: "Endure",
    move4: "Overheat",
    abilities: "Flash Fire",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "128",
  },
  {
    type: "Fire",
    style: "4 7 4 0",
    species: "Flareon",
    set: "4",
    nature: "Quiet",
    item: "Quick Claw",
    move1: "Overheat",
    move2: "Sunny Day",
    move3: "Double-Edge",
    move4: "Shadow Ball",
    abilities: "Flash Fire",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "76",
  },
  {
    type: "Dragon Ground",
    style: "0 0 0 4",
    species: "Flygon",
    set: "1",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Earthquake",
    move2: "Steel Wing",
    move3: "Faint Attack",
    move4: "Facade",
    abilities: "Levitate",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Dragon Ground",
    style: "0 0 0 7",
    species: "Flygon",
    set: "2",
    nature: "Modest",
    item: "Bright Powder",
    move1: "SolarBeam",
    move2: "Fire Blast",
    move3: "Crunch",
    move4: "Sunny Day",
    abilities: "Levitate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Dragon Ground",
    style: "0 0 0 0",
    species: "Flygon",
    set: "3",
    nature: "Hardy",
    item: "Scope Lens",
    move1: "Earthquake",
    move2: "Dragon Claw",
    move3: "Flamethrower",
    move4: "Giga Drain",
    abilities: "Levitate",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "141",
  },
  {
    type: "Dragon Ground",
    style: "0 0 4 0",
    species: "Flygon",
    set: "4",
    nature: "Hardy",
    item: "Scope Lens",
    move1: "Earthquake",
    move2: "Dragon Claw",
    move3: "Double-Edge",
    move4: "Crunch",
    abilities: "Levitate",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "141",
  },
  {
    type: "Bug Steel",
    style: "4 0 3 2",
    species: "Forretress",
    set: "1",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Double-Edge",
    move2: "Rock Slide",
    move3: "Light Screen",
    move4: "Spikes",
    abilities: "Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "60",
  },
  {
    type: "Bug Steel",
    style: "0 4 4 3",
    species: "Forretress",
    set: "2",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Earthquake",
    move2: "Double-Edge",
    move3: "Counter",
    move4: "Protect",
    abilities: "Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "60",
  },
  {
    type: "Bug Steel",
    style: "4 0 0 0",
    species: "Forretress",
    set: "3",
    nature: "Quiet",
    item: "Focus Band",
    move1: "Explosion",
    move2: "Earthquake",
    move3: "Giga Drain",
    move4: "Zap Cannon",
    abilities: "Sturdy",
    evs: " 0 /170/ 0 /170/170/ 0 ",
    speed: "54",
  },
  {
    type: "Bug Steel",
    style: "4 0 0 4",
    species: "Forretress",
    set: "4",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Explosion",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Double-Edge",
    abilities: "Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "60",
  },
  {
    type: "Psychic",
    style: "0 2 0 3",
    species: "Gardevoir",
    set: "1",
    nature: "Timid",
    item: "Leftovers",
    move1: "Dream Eater",
    move2: "Hypnosis",
    move3: "Magical Leaf",
    move4: "Reflect",
    abilities: "Synchronize / Trace",
    evs: "170/ 0 /170/ 0 / 0 /170",
    speed: "133",
  },
  {
    type: "Psychic",
    style: "0 1 1 3",
    species: "Gardevoir",
    set: "2",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Psychic",
    move2: "Calm Mind",
    move3: "Double Team",
    move4: "Rest",
    abilities: "Synchronize / Trace",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "100",
  },
  {
    type: "Psychic",
    style: "0 0 0 0",
    species: "Gardevoir",
    set: "3",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Ice Punch",
    move3: "Fire Punch",
    move4: "Magical Leaf",
    abilities: "Synchronize / Trace",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "132",
  },
  {
    type: "Psychic",
    style: "0 0 0 0",
    species: "Gardevoir",
    set: "4",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Ice Punch",
    move4: "Fire Punch",
    abilities: "Synchronize / Trace",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "132",
  },
  {
    type: "Psychic",
    style: "0 0 3 4",
    species: "Gardevoir",
    set: "5",
    nature: "Docile",
    item: "Salac Berry",
    move1: "Psychic",
    move2: "Shadow Ball",
    move3: "Endure",
    move4: "Destiny Bond",
    abilities: "Synchronize / Trace",
    evs: "170/ 0 /170/ 0 / 0 /170",
    speed: "121",
  },
  {
    type: "Psychic",
    style: "0 0 2 4",
    species: "Gardevoir",
    set: "6",
    nature: "Timid",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Will-O-Wisp",
    move4: "Destiny Bond",
    abilities: "Synchronize / Trace",
    evs: "255/ 0 / 0 / 0 / 0 /255",
    speed: "145",
  },
  {
    type: "Psychic",
    style: "0 1 2 4",
    species: "Gardevoir",
    set: "7",
    nature: "Bold",
    item: "Quick Claw",
    move1: "Psychic",
    move2: "Calm Mind",
    move3: "Will-O-Wisp",
    move4: "Destiny Bond",
    abilities: "Synchronize / Trace",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "100",
  },
  {
    type: "Psychic",
    style: "0 0 2 1",
    species: "Gardevoir",
    set: "8",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Magical Leaf",
    move3: "Attract",
    move4: "Double Team",
    abilities: "Synchronize / Trace",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "132",
  },
  {
    type: "Ghost Poison",
    style: "0 2 2 2",
    species: "Gengar",
    set: "1",
    nature: "Timid",
    item: "Leftovers",
    move1: "Dream Eater",
    move2: "Hypnosis",
    move3: "Confuse Ray",
    move4: "Attract",
    abilities: "Levitate",
    evs: "170/ 0 / 0 /170/ 0 /170",
    speed: "166",
  },
  {
    type: "Ghost Poison",
    style: "0 0 2 2",
    species: "Gengar",
    set: "2",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Sludge Bomb",
    move2: "Shadow Ball",
    move3: "Confuse Ray",
    move4: "Will-O-Wisp",
    abilities: "Levitate",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "162",
  },
  {
    type: "Ghost Poison",
    style: "0 0 0 6",
    species: "Gengar",
    set: "3",
    nature: "Modest",
    item: "Quick Claw",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Giga Drain",
    move4: "Skill Swap",
    abilities: "Levitate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "162",
  },
  {
    type: "Ghost Poison",
    style: "0 0 0 4",
    species: "Gengar",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Fire Punch",
    move3: "Ice Punch",
    move4: "Destiny Bond",
    abilities: "Levitate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "162",
  },
  {
    type: "Ghost Poison",
    style: "0 0 0 0",
    species: "Gengar",
    set: "5",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Shadow Ball",
    move3: "Thunderbolt",
    move4: "Fire Punch",
    abilities: "Levitate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "162",
  },
  {
    type: "Ghost Poison",
    style: "0 0 0 0",
    species: "Gengar",
    set: "6",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Shadow Ball",
    move3: "Thunderbolt",
    move4: "Ice Punch",
    abilities: "Levitate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "162",
  },
  {
    type: "Ghost Poison",
    style: "0 0 0 4",
    species: "Gengar",
    set: "7",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Fire Punch",
    move4: "Destiny Bond",
    abilities: "Levitate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "162",
  },
  {
    type: "Ghost Poison",
    style: "0 0 0 4",
    species: "Gengar",
    set: "8",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Ice Punch",
    move4: "Destiny Bond",
    abilities: "Levitate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "162",
  },
  {
    type: "Ice",
    style: "0 0 7 3",
    species: "Glalie",
    set: "1",
    nature: "Modest",
    item: "Petaya Berry",
    move1: "Ice Beam",
    move2: "Crunch",
    move3: "Hail",
    move4: "Protect",
    abilities: "Inner Focus",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Ice",
    style: "4 3 0 0",
    species: "Glalie",
    set: "2",
    nature: "Quirky",
    item: "Salac Berry",
    move1: "Explosion",
    move2: "Endure",
    move3: "Body Slam",
    move4: "Icy Wind",
    abilities: "Inner Focus",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "132",
  },
  {
    type: "Ice",
    style: "0 0 4 0",
    species: "Glalie",
    set: "3",
    nature: "Hardy",
    item: "Shell Bell",
    move1: "Blizzard",
    move2: "Earthquake",
    move3: "Double-Edge",
    move4: "Shadow Ball",
    abilities: "Inner Focus",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "121",
  },
  {
    type: "Ice",
    style: "0 0 0 0",
    species: "Glalie",
    set: "4",
    nature: "Hardy",
    item: "Leftovers",
    move1: "Ice Beam",
    move2: "Earthquake",
    move3: "Crunch",
    move4: "Shadow Ball",
    abilities: "Inner Focus",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Water",
    style: "0 0 0 3",
    species: "Golduck",
    set: "1",
    nature: "Quiet",
    item: "Shell Bell",
    move1: "Hydro Pump",
    move2: "Dig",
    move3: "Brick Break",
    move4: "Light Screen",
    abilities: "Damp / Cloud Nine",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "94",
  },
  {
    type: "Water",
    style: "0 0 2 1",
    species: "Golduck",
    set: "2",
    nature: "Quirky",
    item: "Lum Berry",
    move1: "Cross Chop",
    move2: "Surf",
    move3: "Swagger",
    move4: "Psych Up",
    abilities: "Damp / Cloud Nine",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "126",
  },
  {
    type: "Water",
    style: "0 0 0 3",
    species: "Golduck",
    set: "3",
    nature: "Docile",
    item: "Shell Bell",
    move1: "Hydro Pump",
    move2: "Cross Chop",
    move3: "Blizzard",
    move4: "Protect",
    abilities: "Damp / Cloud Nine",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Water",
    style: "0 0 0 0",
    species: "Golduck",
    set: "4",
    nature: "Docile",
    item: "Scope Lens",
    move1: "Surf",
    move2: "Cross Chop",
    move3: "Ice Beam",
    move4: "Aerial Ace",
    abilities: "Damp / Cloud Nine",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "137",
  },
  {
    type: "Ground Rock",
    style: "0 0 4 0",
    species: "Golem",
    set: "1",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Earthquake",
    move2: "Body Slam",
    move3: "Counter",
    move4: "Rock Tomb",
    abilities: "Rock Head / Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "65",
  },
  {
    type: "Ground Rock",
    style: "4 6 1 3",
    species: "Golem",
    set: "2",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Focus Punch",
    move2: "Substitute",
    move3: "Double Team",
    move4: "Rest",
    abilities: "Rock Head / Sturdy",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "65",
  },
  {
    type: "Ground Rock",
    style: "4 0 0 0",
    species: "Golem",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Explosion",
    move2: "Earthquake",
    move3: "Flamethrower",
    move4: "Brick Break",
    abilities: "Rock Head / Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "65",
  },
  {
    type: "Ground Rock",
    style: "4 0 0 4",
    species: "Golem",
    set: "4",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Explosion",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Double-Edge",
    abilities: "Rock Head / Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "65",
  },
  {
    type: "Normal",
    style: "0 0 2 0",
    species: "Granbull",
    set: "1",
    nature: "Adamant",
    item: "Cheri Berry",
    move1: "Mega Kick",
    move2: "SmellingSalt",
    move3: "Thunder Wave",
    move4: "Roar",
    abilities: "Intimidate",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "65",
  },
  {
    type: "Normal",
    style: "4 0 0 4",
    species: "Granbull",
    set: "2",
    nature: "Quiet",
    item: "White Herb",
    move1: "Overheat",
    move2: "Thunderbolt",
    move3: "Ice Punch",
    move4: "Facade",
    abilities: "Intimidate",
    evs: " 0 / 0 / 0 /255/255/ 0 ",
    speed: "58",
  },
  {
    type: "Normal",
    style: "4 0 0 0",
    species: "Granbull",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Sludge Bomb",
    move4: "Rock Slide",
    abilities: "Intimidate",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "65",
  },
  {
    type: "Normal",
    style: "0 0 0 0 ",
    species: "Granbull",
    set: "4",
    nature: "Brave",
    item: "Choice Band",
    move1: "Mega Kick",
    move2: "Earthquake",
    move3: "Crunch",
    move4: "Shadow Ball",
    abilities: "Intimidate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "58",
  },
  {
    type: "Flying Water",
    style: "0 0 2 1",
    species: "Gyarados",
    set: "1",
    nature: "Careful",
    item: "Lum Berry",
    move1: "Return",
    move2: "Bite",
    move3: "Thunder Wave",
    move4: "Dragon Dance",
    abilities: "Intimidate",
    evs: "255/ 0 / 0 / 0 /255/ 0 ",
    speed: "101",
  },
  {
    type: "Flying Water",
    style: "0 0 0 0",
    species: "Gyarados",
    set: "2",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Hydro Pump",
    move2: "Thunderbolt",
    move3: "Fire Blast",
    move4: "Blizzard",
    abilities: "Intimidate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "133",
  },
  {
    type: "Flying Water",
    style: "0 0 7 0",
    species: "Gyarados",
    set: "3",
    nature: "Quirky",
    item: "Quick Claw",
    move1: "Surf",
    move2: "Thunder",
    move3: "Rain Dance",
    move4: "Earthquake",
    abilities: "Intimidate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "101",
  },
  {
    type: "Flying Water",
    style: "0 0 1 3",
    species: "Gyarados",
    set: "4",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Return",
    move2: "Earthquake",
    move3: "Dragon Dance",
    move4: "Rest",
    abilities: "Intimidate",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "101",
  },
  {
    type: "Fighting",
    style: "0 0 4 0",
    species: "Hariyama",
    set: "1",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Cross Chop",
    move2: "Rock Slide",
    move3: "Counter",
    move4: "Fake Out",
    abilities: "Thick Fat / Guts",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "70",
  },
  {
    type: "Fighting",
    style: "0 0 0 0",
    species: "Hariyama",
    set: "2",
    nature: "Quiet",
    item: "Quick Claw",
    move1: "Cross Chop",
    move2: "Fire Punch",
    move3: "Ice Punch",
    move4: "Thunder Punch",
    abilities: "Thick Fat / Guts",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "63",
  },
  {
    type: "Fighting",
    style: "0 0 0 4",
    species: "Hariyama",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Cross Chop",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Facade",
    abilities: "Thick Fat / Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Fighting",
    style: "0 0 0 0",
    species: "Hariyama",
    set: "4",
    nature: "Adamant",
    item: "Scope Lens",
    move1: "Cross Chop",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Fake Out",
    abilities: "Thick Fat / Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Bug Fighting",
    style: "0 0 0 4",
    species: "Heracross",
    set: "1",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Megahorn",
    move2: "Brick Break",
    move3: "Rock Tomb",
    move4: "Counter",
    abilities: "Swarm / Guts",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "105",
  },
  {
    type: "Bug Fighting",
    style: "0 0 2 1",
    species: "Heracross",
    set: "2",
    nature: "Jolly",
    item: "Lum Berry",
    move1: "Megahorn",
    move2: "Earthquake",
    move3: "Attract",
    move4: "Bulk Up",
    abilities: "Swarm / Guts",
    evs: "255/ 0 / 0 / 0 / 0 /255",
    speed: "150",
  },
  {
    type: "Bug Fighting",
    style: "0 0 0 0",
    species: "Heracross",
    set: "3",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Megahorn",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Brick Break",
    abilities: "Swarm / Guts",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "137",
  },
  {
    type: "Bug Fighting",
    style: "0 0 4 3",
    species: "Heracross",
    set: "4",
    nature: "Adamant",
    item: "Salac Berry",
    move1: "Megahorn",
    move2: "Earthquake",
    move3: "Reversal",
    move4: "Endure",
    abilities: "Swarm / Guts",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "137",
  },
  {
    type: "Dark Fire",
    style: "0 0 4 2",
    species: "Houndoom",
    set: "1",
    nature: "Quirky",
    item: "Focus Band",
    move1: "Flamethrower",
    move2: "Shadow Ball",
    move3: "Counter",
    move4: "Will-O-Wisp",
    abilities: "Early Bird / Flash Fire",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "136",
  },
  {
    type: "Dark Fire",
    style: "0 0 0 3",
    species: "Houndoom",
    set: "2",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Fire Blast",
    move2: "Crunch",
    move3: "Roar",
    move4: "Rest",
    abilities: "Early Bird / Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "147",
  },
  {
    type: "Dark Fire",
    style: "4 0 0 4",
    species: "Houndoom",
    set: "3",
    nature: "Quirky",
    item: "White Herb",
    move1: "Overheat",
    move2: "Shadow Ball",
    move3: "Sludge Bomb",
    move4: "Double-Edge",
    abilities: "Early Bird / Flash Fire",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "147",
  },
  {
    type: "Dark Fire",
    style: "4 0 0 7",
    species: "Houndoom",
    set: "4",
    nature: "Modest",
    item: "White Herb",
    move1: "Overheat",
    move2: "SolarBeam",
    move3: "Crunch",
    move4: "Sunny Day",
    abilities: "Early Bird / Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "147",
  },
  {
    type: "Psychic",
    style: "0 0 0 2",
    species: "Hypno",
    set: "1",
    nature: "Quiet",
    item: "TwistedSpoon",
    move1: "Thunder Punch",
    move2: "Fire Punch",
    move3: "Ice Punch",
    move4: "Hypnosis",
    abilities: "Insomnia",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "78",
  },
  {
    type: "Psychic",
    style: "2 0 0 0",
    species: "Hypno",
    set: "2",
    nature: "Modest",
    item: "TwistedSpoon",
    move1: "Hypnosis",
    move2: "Nightmare",
    move3: "Dream Eater",
    move4: "Psychic",
    abilities: "Insomnia",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "87",
  },
  {
    type: "Psychic",
    style: "1 2 0 0",
    species: "Hypno",
    set: "3",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Psych Up",
    move2: "Swagger",
    move3: "Mega Kick",
    move4: "Shadow Ball",
    abilities: "Insomnia",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "87",
  },
  {
    type: "Psychic",
    style: "0 0 0 0",
    species: "Hypno",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Thunder Punch",
    move3: "Fire Punch",
    move4: "Ice Punch",
    abilities: "Insomnia",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "87",
  },
  {
    type: "Electric",
    style: "0 2 2 3",
    species: "Jolteon",
    set: "1",
    nature: "Modest",
    item: "Cheri Berry",
    move1: "Thunderbolt",
    move2: "Thunder Wave",
    move3: "Attract",
    move4: "Protect",
    abilities: "Volt Absorb",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "182",
  },
  {
    type: "Electric",
    style: "0 0 0 0",
    species: "Jolteon",
    set: "2",
    nature: "Hardy",
    item: "Scope Lens",
    move1: "Thunderbolt",
    move2: "Dig",
    move3: "Double Kick",
    move4: "Roar",
    abilities: "Volt Absorb",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "150",
  },
  {
    type: "Electric",
    style: "0 2 1 3",
    species: "Jolteon",
    set: "3",
    nature: "Bold",
    item: "Bright Powder",
    move1: "Thunderbolt",
    move2: "Thunder Wave",
    move3: "Agility",
    move4: "Baton Pass",
    abilities: "Volt Absorb",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "150",
  },
  {
    type: "Electric",
    style: "0 2 0 0",
    species: "Jolteon",
    set: "4",
    nature: "Timid",
    item: "King's Rock",
    move1: "Thunderbolt",
    move2: "Thunder Wave",
    move3: "Bite",
    move4: "Shadow Ball",
    abilities: "Volt Absorb",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "200",
  },
  {
    type: "Ice Psychic",
    style: "0 0 2 2",
    species: "Jynx",
    set: "1",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Ice Beam",
    move2: "Fake Out",
    move3: "Lovely Kiss",
    move4: "Attract",
    abilities: "Oblivious",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "115",
  },
  {
    type: "Ice Psychic",
    style: "4 2 2 3",
    species: "Jynx",
    set: "2",
    nature: "Impish",
    item: "Bright Powder",
    move1: "Perish Song",
    move2: "Mean Look",
    move3: "Lovely Kiss",
    move4: "Protect",
    abilities: "Oblivious",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "115",
  },
  {
    type: "Ice Psychic",
    style: "0 2 2 6",
    species: "Jynx",
    set: "3",
    nature: "Hardy",
    item: "Quick Claw",
    move1: "Dream Eater",
    move2: "Lovely Kiss",
    move3: "Attract",
    move4: "Substitute",
    abilities: "Oblivious",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "115",
  },
  {
    type: "Ice Psychic",
    style: "0 0 2 5",
    species: "Jynx",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Ice Beam",
    move3: "Lovely Kiss",
    move4: "Fake Tears",
    abilities: "Oblivious",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "115",
  },
  {
    type: "Normal",
    style: "0 0 4 0",
    species: "Kangaskhan",
    set: "1",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Dizzy Punch",
    move2: "Brick Break",
    move3: "Counter",
    move4: "Fake Out",
    abilities: "Early Bird",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "110",
  },
  {
    type: "Normal",
    style: "0 0 2 3",
    species: "Kangaskhan",
    set: "2",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Crush Claw",
    move2: "Shadow Ball",
    move3: "Attract",
    move4: "Rest",
    abilities: "Early Bird",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "110",
  },
  {
    type: "Normal",
    style: "4 3 0 0",
    species: "Kangaskhan",
    set: "3",
    nature: "Jolly",
    item: "Salac Berry",
    move1: "Reversal",
    move2: "Endure",
    move3: "Thunderbolt",
    move4: "Earthquake",
    abilities: "Early Bird",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "156",
  },
  {
    type: "Normal",
    style: "0 0 0 0",
    species: "Kangaskhan",
    set: "4",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Mega Kick",
    move2: "Earthquake",
    move3: "Aerial Ace",
    move4: "Shadow Ball",
    abilities: "Early Bird",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "142",
  },
  {
    type: "Dragon Water",
    style: "0 0 0 2",
    species: "Kingdra",
    set: "1",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Hydro Pump",
    move2: "Dragon Breath",
    move3: "Icy Wind",
    move4: "Attract",
    abilities: "Swift Swim",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Dragon Water",
    style: "0 0 0 3",
    species: "Kingdra",
    set: "2",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Dragon Breath",
    move4: "Rest",
    abilities: "Swift Swim",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "105",
  },
  {
    type: "Dragon Water",
    style: "4 0 1 3",
    species: "Kingdra",
    set: "3",
    nature: "Adamant",
    item: "Salac Berry",
    move1: "Flail",
    move2: "Hydro Pump",
    move3: "Dragon Dance",
    move4: "Endure",
    abilities: "Swift Swim",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "105",
  },
  {
    type: "Dragon Water",
    style: "4 0 1 3",
    species: "Kingdra",
    set: "4",
    nature: "Hardy",
    item: "Chesto Berry",
    move1: "Double-Edge",
    move2: "Ice Beam",
    move3: "Dragon Dance",
    move4: "Rest",
    abilities: "Swift Swim",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "105",
  },
  {
    type: "Electric Water",
    style: "0 2 2 2",
    species: "Lanturn",
    set: "1",
    nature: "Quiet",
    item: "Cheri Berry",
    move1: "Surf",
    move2: "Confuse Ray",
    move3: "Attract",
    move4: "Thunder Wave",
    abilities: "Volt Absorb / Illuminate",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "78",
  },
  {
    type: "Electric Water",
    style: "4 3 0 0",
    species: "Lanturn",
    set: "2",
    nature: "Docile",
    item: "Salac Berry",
    move1: "Flail",
    move2: "Endure",
    move3: "Thunderbolt",
    move4: "Surf",
    abilities: "Volt Absorb / Illuminate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "87",
  },
  {
    type: "Electric Water",
    style: "0 0 2 7",
    species: "Lanturn",
    set: "3",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Hydro Pump",
    move2: "Thunder",
    move3: "Confuse Ray",
    move4: "Rain Dance",
    abilities: "Volt Absorb / Illuminate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "119",
  },
  {
    type: "Electric Water",
    style: "0 0 0 2",
    species: "Lanturn",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Surf",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Confuse Ray",
    abilities: "Volt Absorb / Illuminate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "119",
  },
  {
    type: "Ice Water",
    style: "0 2 2 2",
    species: "Lapras",
    set: "1",
    nature: "Bold",
    item: "Leftovers",
    move1: "Surf",
    move2: "Attract",
    move3: "Confuse Ray",
    move4: "Sing",
    abilities: "Water Absorb / Shell Armor",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "80",
  },
  {
    type: "Ice Water",
    style: "0 0 0 0",
    species: "Lapras",
    set: "2",
    nature: "Timid",
    item: "Quick Claw",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Body Slam",
    move4: "Roar",
    abilities: "Water Absorb / Shell Armor",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "123",
  },
  {
    type: "Ice Water",
    style: "4 0 2 1",
    species: "Lapras",
    set: "3",
    nature: "Docile",
    item: "Bright Powder",
    move1: "Double-Edge",
    move2: "Psychic",
    move3: "Confuse Ray",
    move4: "Dragon Dance",
    abilities: "Water Absorb / Shell Armor",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "80",
  },
  {
    type: "Ice Water",
    style: "0 0 0 0",
    species: "Lapras",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Thunderbolt",
    move4: "Psychic",
    abilities: "Water Absorb / Shell Armor",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "80",
  },
  {
    type: "Ice Water",
    style: "0 0 0 4",
    species: "Lapras",
    set: "5",
    nature: "Docile",
    item: "Shell Bell",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Iron Tail",
    move4: "Double-Edge",
    abilities: "Water Absorb / Shell Armor",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "80",
  },
  {
    type: "Ice Water",
    style: "0 0 7 0",
    species: "Lapras",
    set: "6",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Hydro Pump",
    move2: "Thunder",
    move3: "Rain Dance",
    move4: "Blizzard",
    abilities: "Water Absorb / Shell Armor",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "80",
  },
  {
    type: "Ice Water",
    style: "0 4 3 0",
    species: "Lapras",
    set: "7",
    nature: "Calm",
    item: "Leppa Berry",
    move1: "Sheer Cold",
    move2: "Horn Drill",
    move3: "Rest",
    move4: "Sleep Talk",
    abilities: "Water Absorb / Shell Armor",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "80",
  },
  {
    type: "Ice Water",
    style: "0 4 2 2",
    species: "Lapras",
    set: "8",
    nature: "Calm",
    item: "Quick Claw",
    move1: "Sheer Cold",
    move2: "Horn Drill",
    move3: "Sing",
    move4: "Attract",
    abilities: "Water Absorb / Shell Armor",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "80",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 0",
    species: "Latias",
    set: "1",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Dragon Claw",
    abilities: "Levitate",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 0",
    species: "Latias",
    set: "2",
    nature: "Docile",
    item: "Quick Claw",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Earthquake",
    abilities: "Levitate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 0",
    species: "Latias",
    set: "3",
    nature: "Docile",
    item: "Focus Band",
    move1: "Dragon Claw",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Earthquake",
    abilities: "Levitate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 5 3",
    species: "Latias",
    set: "4",
    nature: "Docile",
    item: "Leftovers",
    move1: "Mist Ball",
    move2: "Shadow Ball",
    move3: "Charm",
    move4: "Reflect",
    abilities: "Levitate",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 2 1 3",
    species: "Latias",
    set: "5",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Dragon Claw",
    move2: "Thunder Wave",
    move3: "Calm Mind",
    move4: "Recover",
    abilities: "Levitate",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 2 2",
    species: "Latias",
    set: "6",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Mist Ball",
    move2: "Dragon Claw",
    move3: "Attract",
    move4: "Thunder Wave",
    abilities: "Levitate",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 2 1",
    species: "Latias",
    set: "7",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Earthquake",
    move2: "Shadow Ball",
    move3: "Swagger",
    move4: "Psych Up",
    abilities: "Levitate",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 0",
    species: "Latias",
    set: "8",
    nature: "Docile",
    item: "King's Rock",
    move1: "Psychic",
    move2: "Shadow Ball",
    move3: "Earthquake",
    move4: "Aerial Ace",
    abilities: "Levitate",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "151",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 0",
    species: "Latios",
    set: "1",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Dragon Claw",
    abilities: "Levitate",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 0",
    species: "Latios",
    set: "2",
    nature: "Docile",
    item: "Quick Claw",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Earthquake",
    abilities: "Levitate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 0",
    species: "Latios",
    set: "3",
    nature: "Docile",
    item: "Focus Band",
    move1: "Dragon Claw",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Earthquake",
    abilities: "Levitate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 0",
    species: "Latios",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Luster Purge",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Dragon Claw",
    abilities: "Levitate",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 2 1 3",
    species: "Latios",
    set: "5",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Dragon Claw",
    move2: "Thunder Wave",
    move3: "Calm Mind",
    move4: "Recover",
    abilities: "Levitate",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 2",
    species: "Latios",
    set: "6",
    nature: "Docile",
    item: "Shell Bell",
    move1: "Luster Purge",
    move2: "Shadow Ball",
    move3: "Dragon Claw",
    move4: "Thunder Wave",
    abilities: "Levitate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 1 3",
    species: "Latios",
    set: "7",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Earthquake",
    move2: "Shadow Ball",
    move3: "Dragon Dance",
    move4: "Recover",
    abilities: "Levitate",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "130",
  },
  {
    type: "Dragon Psychic",
    style: "0 0 0 0",
    species: "Latios",
    set: "8",
    nature: "Docile",
    item: "King's Rock",
    move1: "Psychic",
    move2: "Shadow Ball",
    move3: "Earthquake",
    move4: "Aerial Ace",
    abilities: "Levitate",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "151",
  },
  {
    type: "Grass Water",
    style: "0 7 0 0 ",
    species: "Ludicolo",
    set: "1",
    nature: "Quiet",
    item: "Shell Bell",
    move1: "Surf",
    move2: "Rain Dance",
    move3: "Thunder Punch",
    move4: "Fire Punch",
    abilities: "Swift Swim / Rain Dish",
    evs: "170/ 0 /170/170/ 0 / 0 ",
    speed: "81",
  },
  {
    type: "Grass Water",
    style: "0 0 0 0",
    species: "Ludicolo",
    set: "2",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Thunder Punch",
    move4: "Fire Punch",
    abilities: "Swift Swim / Rain Dish",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Grass Water",
    style: "2 7 2 0",
    species: "Ludicolo",
    set: "3",
    nature: "Bold",
    item: "Leftovers",
    move1: "Leech Seed",
    move2: "Rain Dance",
    move3: "Double Team",
    move4: "Giga Drain",
    abilities: "Swift Swim / Rain Dish",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "90",
  },
  {
    type: "Grass Water",
    style: "2 7 1 2",
    species: "Ludicolo",
    set: "4",
    nature: "Bold",
    item: "Leftovers",
    move1: "Leech Seed",
    move2: "Rain Dance",
    move3: "Double Team",
    move4: "Toxic",
    abilities: "Swift Swim / Rain Dish",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "90",
  },
  {
    type: "Fighting",
    style: "0 0 4 5",
    species: "Machamp",
    set: "1",
    nature: "Adamant",
    item: "Scope Lens",
    move1: "Cross Chop",
    move2: "Rock Slide",
    move3: "Counter",
    move4: "Scary Face",
    abilities: "Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "75",
  },
  {
    type: "Fighting",
    style: "0 0 1 3",
    species: "Machamp",
    set: "2",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Cross Chop",
    move2: "Earthquake",
    move3: "Bulk Up",
    move4: "Rest",
    abilities: "Guts",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "75",
  },
  {
    type: "Fighting",
    style: "0 0 0 0",
    species: "Machamp",
    set: "3",
    nature: "Hardy",
    item: "Quick Claw",
    move1: "Cross Chop",
    move2: "Fire Blast",
    move3: "Thunder Punch",
    move4: "Ice Punch",
    abilities: "Guts",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "75",
  },
  {
    type: "Fighting ",
    style: "0 0 0 0",
    species: "Machamp",
    set: "4",
    nature: "Hardy",
    item: "Scope Lens",
    move1: "Cross Chop",
    move2: "Earthquake",
    move3: "Flamethrower",
    move4: "Rock Slide",
    abilities: "Guts",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "75",
  },
  {
    type: "Fighting",
    style: "0 4 0 0",
    species: "Machamp",
    set: "5",
    nature: "Adamant",
    item: "Scope Lens",
    move1: "Cross Chop",
    move2: "Double-Edge",
    move3: "Earthquake",
    move4: "Rock Slide",
    abilities: "Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "75",
  },
  {
    type: "Fighting",
    style: "0 0 4 0",
    species: "Machamp",
    set: "6",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Cross Chop",
    move2: "Earthquake",
    move3: "Counter",
    move4: "Rock Tomb",
    abilities: "Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "75",
  },
  {
    type: "Fighting",
    style: "4 6 2 1",
    species: "Machamp",
    set: "7",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Focus Punch",
    move2: "Substitute",
    move3: "Attract",
    move4: "Double Team",
    abilities: "Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "75",
  },
  {
    type: "Fighting",
    style: "4 0 4 4",
    species: "Machamp",
    set: "8",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Revenge",
    move2: "Rock Slide",
    move3: "Facade",
    move4: "Counter",
    abilities: "Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "75",
  },
  {
    type: "Fire",
    style: "0 5 0 1",
    species: "Magmar",
    set: "1",
    nature: "Relaxed",
    item: "Rawst Berry",
    move1: "Flamethrower",
    move2: "SmokeScreen",
    move3: "Brick Break",
    move4: "Barrier",
    abilities: "Flame Body",
    evs: "170/ 0 /170/170/ 0 / 0 ",
    speed: "102",
  },
  {
    type: "Fire",
    style: "0 5 0 2",
    species: "Magmar",
    set: "2",
    nature: "Modest",
    item: "Quick Claw",
    move1: "Fire Blast",
    move2: "SmokeScreen",
    move3: "Thunder Punch",
    move4: "Confuse Ray",
    abilities: "Flame Body",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "145",
  },
  {
    type: "Fire",
    style: "0 0 0 4",
    species: "Magmar",
    set: "3",
    nature: "Impish",
    item: "Scope Lens",
    move1: "Mega Kick",
    move2: "Cross Chop",
    move3: "Iron Tail",
    move4: "Counter",
    abilities: "Flame Body",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "113",
  },
  {
    type: "Fire",
    style: "0 0 0 2",
    species: "Magmar",
    set: "4",
    nature: "Docile",
    item: "Scope Lens",
    move1: "Flamethrower",
    move2: "Psychic",
    move3: "Cross Chop",
    move4: "Confuse Ray",
    abilities: "Flame Body",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "113",
  },
  {
    type: "Electric",
    style: "0 5 0 0",
    species: "Manectric",
    set: "1",
    nature: "Modest",
    item: "Magnet",
    move1: "Thunderbolt",
    move2: "Flash",
    move3: "Quick Attack",
    move4: "Roar",
    abilities: "Static / Lightningrod",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "157",
  },
  {
    type: "Electric",
    style: "0 7 0 0",
    species: "Manectric",
    set: "2",
    nature: "Modest",
    item: "Petaya Berry",
    move1: "Thunder",
    move2: "Rain Dance",
    move3: "Crunch",
    move4: "Roar",
    abilities: "Static / Lightningrod",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "157",
  },
  {
    type: "Electric",
    style: "0 0 2 0",
    species: "Manectric",
    set: "3",
    nature: "Quirky",
    item: "Lum Berry",
    move1: "Thunderbolt",
    move2: "Iron Tail",
    move3: "Thunder Wave",
    move4: "Roar",
    abilities: "Static / Lightningrod",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "157",
  },
  {
    type: "Electric",
    style: "0 0 2 0",
    species: "Manectric",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Thunderbolt",
    move2: "Crunch",
    move3: "Thunder Wave",
    move4: "Roar",
    abilities: "Static / Lightningrod",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "157",
  },
  {
    type: "Ground",
    style: "0 0 0 0",
    species: "Marowak",
    set: "1",
    nature: "Adamant",
    item: "Thick Club",
    move1: "Bonemerang",
    move2: "Rock Slide",
    move3: "Icy Wind",
    move4: "Headbutt",
    abilities: "Rock Head / Lightningrod",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "65",
  },
  {
    type: "Ground",
    style: "0 0 1 0",
    species: "Marowak",
    set: "2",
    nature: "Adamant",
    item: "Thick Club",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Swords Dance",
    move4: "Icy Wind",
    abilities: "Rock Head / Lightningrod",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "97",
  },
  {
    type: "Ground",
    style: "0 0 1 0",
    species: "Marowak",
    set: "3",
    nature: "Adamant",
    item: "Thick Club",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Swords Dance",
    move4: "Brick Break",
    abilities: "Rock Head / Lightningrod",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "97",
  },
  {
    type: "Ground",
    style: "0 0 1 0",
    species: "Marowak",
    set: "4",
    nature: "Adamant",
    item: "Thick Club",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Swords Dance",
    move4: "Mega Kick",
    abilities: "Rock Head / Lightningrod",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "97",
  },
  {
    type: "Fighting Psychic",
    style: "0 0 1 3",
    species: "Medicham",
    set: "1",
    nature: "Docile",
    item: "Focus Band",
    move1: "Psychic",
    move2: "Hi Jump Kick",
    move3: "Calm Mind",
    move4: "Baton Pass",
    abilities: "Pure Power",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "132",
  },
  {
    type: "Fighting Psychic",
    style: "4 3 0 0",
    species: "Medicham",
    set: "2",
    nature: "Hardy",
    item: "Salac Berry",
    move1: "Reversal",
    move2: "Endure",
    move3: "Psychic",
    move4: "Fake Out",
    abilities: "Pure Power",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "132",
  },
  {
    type: "Fighting Psychic",
    style: "0 0 0 0",
    species: "Medicham",
    set: "3",
    nature: "Hardy",
    item: "Scope Lens",
    move1: "DynamicPunch",
    move2: "Thunder Punch",
    move3: "Ice Punch",
    move4: "Fire Punch",
    abilities: "Pure Power",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "132",
  },
  {
    type: "Fighting Psychic",
    style: "0 0 0 0",
    species: "Medicham",
    set: "4",
    nature: "Hardy",
    item: "Lum Berry",
    move1: "Mega Kick",
    move2: "Psychic",
    move3: "Shadow Ball",
    move4: "Rock Slide",
    abilities: "Pure Power",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Grass",
    style: "0 7 3 3",
    species: "Meganium",
    set: "1",
    nature: "Modest",
    item: "Bright Powder",
    move1: "SolarBeam",
    move2: "Sunny Day",
    move3: "Light Screen",
    move4: "Synthesis",
    abilities: "Overgrow",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Grass",
    style: "2 6 1 2",
    species: "Meganium",
    set: "2",
    nature: "Calm",
    item: "Leftovers",
    move1: "Leech Seed",
    move2: "Substitute",
    move3: "Double Team",
    move4: "GrassWhistle",
    abilities: "Overgrow",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "100",
  },
  {
    type: "Grass",
    style: "0 4 3 0",
    species: "Meganium",
    set: "3",
    nature: "Jolly",
    item: "Salac Berry",
    move1: "Earthquake",
    move2: "Flail",
    move3: "Endure",
    move4: "Giga Drain",
    abilities: "Overgrow",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "145",
  },
  {
    type: "Grass",
    style: "0 0 0 0",
    species: "Meganium",
    set: "4",
    nature: "Hardy",
    item: "Bright Powder",
    move1: "Giga Drain",
    move2: "Earthquake",
    move3: "Ancient Power",
    move4: "Body Slam",
    abilities: "Overgrow",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Psychic Steel",
    style: "0 0 4 3",
    species: "Metagross",
    set: "1",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Meteor Mash",
    move2: "Aerial Ace",
    move3: "Facade",
    move4: "Light Screen",
    abilities: "Clear Body",
    evs: " 0 /170/ 0 / 0 /170/170",
    speed: "111",
  },
  {
    type: "Psychic Steel",
    style: "0 0 1 2",
    species: "Metagross",
    set: "2",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Earthquake",
    move2: "Meteor Mash",
    move3: "Psych Up",
    move4: "Swagger",
    abilities: "Clear Body",
    evs: "170/ 0 / 0 / 0 /170/170",
    speed: "111",
  },
  {
    type: "Psychic Steel",
    style: "0 0 1 3",
    species: "Metagross",
    set: "3",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Earthquake",
    move2: "Meteor Mash",
    move3: "Double Team",
    move4: "Rest",
    abilities: "Clear Body",
    evs: "170/170/ 0 / 0 / 0 /170",
    speed: "111",
  },
  {
    type: "Psychic Steel",
    style: "0 0 0 0",
    species: "Metagross",
    set: "4",
    nature: "Hardy",
    item: "Quick Claw",
    move1: "Meteor Mash",
    move2: "Psychic",
    move3: "Earthquake",
    move4: "Shadow Ball",
    abilities: "Clear Body",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Psychic Steel",
    style: "4 0 0 0",
    species: "Metagross",
    set: "5",
    nature: "Jolly",
    item: "Quick Claw",
    move1: "Explosion",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Brick Break",
    abilities: "Clear Body",
    evs: "170/170/ 0 / 0 / 0 /170",
    speed: "122",
  },
  {
    type: "Psychic Steel",
    style: "0 0 0 0",
    species: "Metagross",
    set: "6",
    nature: "Hardy",
    item: "Bright Powder",
    move1: "Meteor Mash",
    move2: "Psychic",
    move3: "Ice Punch",
    move4: "Thunder Punch",
    abilities: "Clear Body",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Psychic Steel",
    style: "0 0 0 0",
    species: "Metagross",
    set: "7",
    nature: "Hardy",
    item: "Shell Bell",
    move1: "Earthquake",
    move2: "Shadow Ball",
    move3: "Ice Punch",
    move4: "Thunder Punch",
    abilities: "Clear Body",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Psychic Steel",
    style: "0 0 0 4",
    species: "Metagross",
    set: "8",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Meteor Mash",
    move2: "Earthquake",
    move3: "Brick Break",
    move4: "Explosion",
    abilities: "Clear Body",
    evs: "170/170/ 0 / 0 / 0 /170",
    speed: "111",
  },
  {
    type: "Water",
    style: "0 0 3 4",
    species: "Milotic",
    set: "1",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Hydro Pump",
    move2: "Icy Wind",
    move3: "Recover",
    move4: "Mirror Coat",
    abilities: "Marvel Scale",
    evs: "170/ 0 /170/170/ 0 / 0 ",
    speed: "101",
  },
  {
    type: "Water",
    style: "0 0 3 4",
    species: "Milotic",
    set: "2",
    nature: "Modest",
    item: "Focus Band",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Safeguard",
    move4: "Mirror Coat",
    abilities: "Marvel Scale",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "101",
  },
  {
    type: "Water",
    style: "0 0 2 3",
    species: "Milotic",
    set: "3",
    nature: "Bold",
    item: "Leftovers",
    move1: "Surf",
    move2: "Blizzard",
    move3: "Attract",
    move4: "Recover",
    abilities: "Marvel Scale",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "101",
  },
  {
    type: "Water",
    style: "0 0 3 4",
    species: "Milotic",
    set: "4",
    nature: "Modest",
    item: "Leftovers",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Recover",
    move4: "Mirror Coat",
    abilities: "Marvel Scale",
    evs: " 0 / 0 /170/170/170/ 0 ",
    speed: "101",
  },
  {
    type: "Normal",
    style: "4 0 4 3",
    species: "Miltank",
    set: "1",
    nature: "Careful",
    item: "Focus Band",
    move1: "Facade",
    move2: "Shadow Ball",
    move3: "Counter",
    move4: "Milk Drink",
    abilities: "Thick Fat",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "120",
  },
  {
    type: "Normal",
    style: "4 0 2 2",
    species: "Miltank",
    set: "2",
    nature: "Careful",
    item: "Leftovers",
    move1: "Focus Punch",
    move2: "Shadow Ball",
    move3: "Attract",
    move4: "Thunder Wave",
    abilities: "Thick Fat",
    evs: "170/170/ 0 / 0 /170/ 0 ",
    speed: "120",
  },
  {
    type: "Normal",
    style: "4 3 0 0",
    species: "Miltank",
    set: "3",
    nature: "Adamant",
    item: "Salac Berry",
    move1: "Reversal",
    move2: "Endure",
    move3: "Earthquake",
    move4: "Shadow Ball",
    abilities: "Thick Fat",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "120",
  },
  {
    type: "Normal",
    style: "4 6 1 3",
    species: "Miltank",
    set: "4",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Double-Edge",
    move2: "Curse",
    move3: "Double Team",
    move4: "Milk Drink",
    abilities: "Thick Fat",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "120",
  },
  {
    type: "Ghost",
    style: "4 0 2 2",
    species: "Misdreavus",
    set: "1",
    nature: "Impish",
    item: "Focus Band",
    move1: "Pain Split",
    move2: "Shadow Ball",
    move3: "Confuse Ray",
    move4: "Thunder Wave",
    abilities: "Levitate",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ghost",
    style: "0 2 2 2",
    species: "Misdreavus",
    set: "2",
    nature: "Bold",
    item: "Leftovers",
    move1: "Psychic",
    move2: "Attract",
    move3: "Thunder Wave",
    move4: "Confuse Ray",
    abilities: "Levitate",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ghost",
    style: "4 2 2 2",
    species: "Misdreavus",
    set: "3",
    nature: "Bold",
    item: "Bright Powder",
    move1: "Perish Song",
    move2: "Mean Look",
    move3: "Thunder Wave",
    move4: "Confuse Ray",
    abilities: "Levitate",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ghost",
    style: "4 0 0 0",
    species: "Misdreavus",
    set: "4",
    nature: "Timid",
    item: "Lum Berry",
    move1: "Destiny Bond",
    move2: "Psychic",
    move3: "Shadow Ball",
    move4: "Thunderbolt",
    abilities: "Levitate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "150",
  },
  {
    type: "Fire Flying",
    style: "0 0 0 0",
    species: "Moltres",
    set: "1",
    nature: "Docile",
    item: "Lum Berry",
    move1: "Flamethrower",
    move2: "Aerial Ace",
    move3: "Mud-Slap",
    move4: "Roar",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "110",
  },
  {
    type: "Fire Flying",
    style: "4 0 1 3",
    species: "Moltres",
    set: "2",
    nature: "Hardy",
    item: "White Herb",
    move1: "Overheat",
    move2: "Aerial Ace",
    move3: "Double Team",
    move4: "Protect",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "110",
  },
  {
    type: "Fire Flying",
    style: "0 7 1 3",
    species: "Moltres",
    set: "3",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Fire Blast",
    move2: "Sunny Day",
    move3: "Double Team",
    move4: "Rest",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "142",
  },
  {
    type: "Fire Flying",
    style: "4 4 0 3",
    species: "Moltres",
    set: "4",
    nature: "Quiet",
    item: "White Herb",
    move1: "Overheat",
    move2: "Double-Edge",
    move3: "Steel Wing",
    move4: "Safeguard",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "99",
  },
  {
    type: "Fire Flying",
    style: "4 7 2 4",
    species: "Moltres",
    set: "5",
    nature: "Docile",
    item: "White Herb",
    move1: "Overheat",
    move2: "Sunny Day",
    move3: "Swagger",
    move4: "Facade",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "142",
  },
  {
    type: "Fire Flying",
    style: "4 4 0 0",
    species: "Moltres",
    set: "6",
    nature: "Docile",
    item: "White Herb",
    move1: "Overheat",
    move2: "Double-Edge",
    move3: "Aerial Ace",
    move4: "Steel Wing",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "110",
  },
  {
    type: "Psychic",
    style: "0 0 0 3",
    species: "Mr. Mime",
    set: "1",
    nature: "Relaxed",
    item: "Leftovers",
    move1: "Psychic",
    move2: "Magical Leaf",
    move3: "Fake Out",
    move4: "Reflect",
    abilities: "Soundproof",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "99",
  },
  {
    type: "Psychic",
    style: "4 2 1 0",
    species: "Mr. Mime",
    set: "2",
    nature: "Adamant",
    item: "Liechi Berry",
    move1: "Baton Pass",
    move2: "Swagger",
    move3: "Psych Up",
    move4: "Psychic",
    abilities: "Soundproof",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "110",
  },
  {
    type: "Psychic",
    style: "6 2 0 0",
    species: "Mr. Mime",
    set: "3",
    nature: "Modest",
    item: "Choice Band",
    move1: "Trick",
    move2: "Torment",
    move3: "Psychic",
    move4: "Thunderbolt",
    abilities: "Soundproof",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "110",
  },
  {
    type: "Psychic",
    style: "0 0 0 0",
    species: "Mr. Mime",
    set: "4",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Ice Punch",
    move4: "Fire Punch",
    abilities: "Soundproof",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "110",
  },
  {
    type: "Poison",
    style: "0 0 5 1",
    species: "Muk",
    set: "1",
    nature: "Adamant",
    item: "Poison Barb",
    move1: "Sludge Bomb",
    move2: "Body Slam",
    move3: "Screech",
    move4: "Minimize",
    abilities: "Stench / Sticky Hold",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Poison",
    style: "6 3 0 0",
    species: "Muk",
    set: "2",
    nature: "Hardy",
    item: "Chesto Berry",
    move1: "Curse",
    move2: "Rest",
    move3: "Sludge Bomb",
    move4: "DynamicPunch",
    abilities: "Stench / Sticky Hold",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Poison",
    style: "0 0 0 0",
    species: "Muk",
    set: "3",
    nature: "Quiet",
    item: "Lum Berry",
    move1: "Sludge Bomb",
    move2: "Thunderbolt",
    move3: "Flamethrower",
    move4: "Ice Punch",
    abilities: "Stench / Sticky Hold",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "63",
  },
  {
    type: "Poison",
    style: "0 0 0 4",
    species: "Muk",
    set: "4",
    nature: "Brave",
    item: "Quick Claw",
    move1: "Sludge Bomb",
    move2: "Brick Break",
    move3: "Giga Drain",
    move4: "Explosion",
    abilities: "Stench / Sticky Hold",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "63",
  },
  {
    type: "Ground Poison",
    style: "4 0 0 4",
    species: "Nidoking",
    set: "1",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Horn Drill",
    move2: "Double Kick",
    move3: "Body Slam",
    move4: "Counter",
    abilities: "Poison Point",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ground Poison",
    style: "0 0 0 0",
    species: "Nidoking",
    set: "2",
    nature: "Adamant",
    item: "Shell Bell",
    move1: "Mega Kick",
    move2: "Earthquake",
    move3: "Shadow Ball",
    move4: "Brick Break",
    abilities: "Poison Point",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ground Poison",
    style: "4 0 0 0",
    species: "Nidoking",
    set: "3",
    nature: "Modest",
    item: "Leppa Berry",
    move1: "Horn Drill",
    move2: "Fire Blast",
    move3: "Blizzard",
    move4: "Surf",
    abilities: "Poison Point",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ground Poison",
    style: "0 0 0 0",
    species: "Nidoking",
    set: "4",
    nature: "Docile",
    item: "Lum Berry",
    move1: "Megahorn",
    move2: "Sludge Bomb",
    move3: "Earthquake",
    move4: "Thunder",
    abilities: "Poison Point",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Ground Poison",
    style: "0 0 0 4",
    species: "Nidoqueen",
    set: "1",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Sludge Bomb",
    move2: "Double Kick",
    move3: "Body Slam",
    move4: "Counter",
    abilities: "Poison Point",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "96",
  },
  {
    type: "Ground Poison ",
    style: "4 0 0 0",
    species: "Nidoqueen",
    set: "2",
    nature: "Adamant",
    item: "Shell Bell",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Aerial Ace",
    move4: "Rock Slide",
    abilities: "Poison Point",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "96",
  },
  {
    type: "Ground Poison",
    style: "0 0 0 0",
    species: "Nidoqueen",
    set: "3",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Thunderbolt",
    move2: "Flamethrower",
    move3: "Ice Beam",
    move4: "Crunch",
    abilities: "Poison Point",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "96",
  },
  {
    type: "Ground Poison",
    style: "0 0 0 0",
    species: "Nidoqueen",
    set: "4",
    nature: "Adamant",
    item: "White Herb",
    move1: "Superpower",
    move2: "Sludge Bomb",
    move3: "Earthquake",
    move4: "Shadow Ball",
    abilities: "Poison Point",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "96",
  },
  {
    type: "Fire",
    style: "0 0 2 2",
    species: "Ninetales",
    set: "1",
    nature: "Modest",
    item: "Rawst Berry",
    move1: "Flamethrower",
    move2: "Roar",
    move3: "Confuse Ray",
    move4: "Will-O-Wisp",
    abilities: "Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Fire",
    style: "0 0 4 7",
    species: "Ninetales",
    set: "2",
    nature: "Quirky",
    item: "Lum Berry",
    move1: "Heat Wave",
    move2: "Body Slam",
    move3: "Grudge",
    move4: "Sunny Day",
    abilities: "Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Fire",
    style: "0 0 2 2",
    species: "Ninetales",
    set: "3",
    nature: "Quirky",
    item: "Bright Powder",
    move1: "Fire Blast",
    move2: "Iron Tail",
    move3: "Confuse Ray",
    move4: "Attract",
    abilities: "Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Fire",
    style: "4 4 2 2",
    species: "Ninetales",
    set: "4",
    nature: "Quirky",
    item: "White Herb",
    move1: "Overheat",
    move2: "Double-Edge",
    move3: "Confuse Ray",
    move4: "Will-O-Wisp",
    abilities: "Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Normal",
    style: "0 0 0 3",
    species: "Porygon2",
    set: "1",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Tri Attack",
    move2: "Aerial Ace",
    move3: "Shadow Ball",
    move4: "Recover",
    abilities: "Trace",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "80",
  },
  {
    type: "Normal",
    style: "0 7 2 3",
    species: "Porygon2",
    set: "2",
    nature: "Modest",
    item: "Lum Berry",
    move1: "SolarBeam",
    move2: "Sunny Day",
    move3: "Thunder Wave",
    move4: "Recover",
    abilities: "Trace",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "80",
  },
  {
    type: "Normal",
    style: "0 0 2 3",
    species: "Porygon2",
    set: "3",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Tri Attack",
    move3: "Thunder Wave",
    move4: "Recover",
    abilities: "Trace",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "80",
  },
  {
    type: "Normal",
    style: "0 0 0 3",
    species: "Porygon2",
    set: "4",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Recover",
    abilities: "Trace",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "80",
  },
  {
    type: "Ground Water",
    style: "0 0 4 0",
    species: "Quagsire",
    set: "1",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Earthquake",
    move2: "Brick Break",
    move3: "Counter",
    move4: "Mud-Slap",
    abilities: "Damp / Water Absorb",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "55",
  },
  {
    type: "Ground Water",
    style: "6 2 2 0",
    species: "Quagsire",
    set: "2",
    nature: "Sassy",
    item: "Leftovers",
    move1: "Curse",
    move2: "Attract",
    move3: "Yawn",
    move4: "Ancient Power",
    abilities: "Damp / Water Absorb",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "49",
  },
  {
    type: "Ground Water",
    style: "0 0 4 6",
    species: "Quagsire",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Earthquake",
    move2: "Sludge Bomb",
    move3: "Double-Edge",
    move4: "Curse",
    abilities: "Damp / Water Absorb",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "55",
  },
  {
    type: "Ground Water",
    style: "0 0 0 1",
    species: "Quagsire",
    set: "4",
    nature: "Sassy",
    item: "Leftovers",
    move1: "Surf",
    move2: "Earthquake",
    move3: "Ice Beam",
    move4: "Amnesia",
    abilities: "Damp / Water Absorb",
    evs: " 0 /170/ 0 /170/170/ 0 ",
    speed: "49",
  },
  {
    type: "Electric",
    style: "0 0 3 1",
    species: "Raichu",
    set: "1",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Thunderbolt",
    move2: "Quick Attack",
    move3: "Light Screen",
    move4: "Double Team",
    abilities: "Static",
    evs: " 0 / 0 /170/170/ 0 /170",
    speed: "141",
  },
  {
    type: "Electric",
    style: "0 4 3 1",
    species: "Raichu",
    set: "2",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Thunderbolt",
    move2: "Reversal",
    move3: "Endure",
    move4: "Agility",
    abilities: "Static",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Electric",
    style: "0 7 0 2",
    species: "Raichu",
    set: "3",
    nature: "Docile",
    item: "Cheri Berry",
    move1: "Thunder",
    move2: "Rain Dance",
    move3: "Iron Tail",
    move4: "Attract",
    abilities: "Static",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Electric",
    style: "0 2 3 0",
    species: "Raichu",
    set: "4",
    nature: "Docile",
    item: "Bright Powder",
    move1: "Thunderbolt",
    move2: "Thunder Wave",
    move3: "Protect",
    move4: "Mega Kick",
    abilities: "Static",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "120",
  },
  {
    type: "Electric",
    style: "0 2 1 3",
    species: "Raikou",
    set: "1",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Thunderbolt",
    move2: "Thunder Wave",
    move3: "Calm Mind",
    move4: "Rest",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Electric",
    style: "0 7 1 3",
    species: "Raikou",
    set: "2",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Thunder",
    move2: "Rain Dance",
    move3: "Double Team",
    move4: "Reflect",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Electric",
    style: "0 2 0 0 ",
    species: "Raikou",
    set: "3",
    nature: "Modest",
    item: "King's Rock",
    move1: "Thunderbolt",
    move2: "Thunder Wave",
    move3: "Quick Attack",
    move4: "Roar",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Electric",
    style: "0 0 2 3",
    species: "Raikou",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Thunderbolt",
    move2: "Bite",
    move3: "Thunder Wave",
    move4: "Reflect",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Electric",
    style: "0 4 0 3",
    species: "Raikou",
    set: "5",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Thunderbolt",
    move2: "Double-Edge",
    move3: "Roar",
    move4: "Reflect",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Electric",
    style: "0 1 6 3",
    species: "Raikou",
    set: "6",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Thunderbolt",
    move2: "Calm Mind",
    move3: "Substitute",
    move4: "Rest",
    abilities: "Pressure",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "135",
  },
  {
    type: "Fire",
    style: "0 0 0 3",
    species: "Rapidash",
    set: "1",
    nature: "Quiet",
    item: "Charcoal",
    move1: "Flamethrower",
    move2: "Double Kick",
    move3: "Quick Attack",
    move4: "Protect",
    abilities: "Run Away / Flash Fire",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "141",
  },
  {
    type: "Fire",
    style: "0 0 1 2",
    species: "Rapidash",
    set: "2",
    nature: "Docile",
    item: "Leftovers",
    move1: "Fire Blast",
    move2: "Bounce",
    move3: "Double Team",
    move4: "Attract",
    abilities: "Run Away / Flash Fire",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "146",
  },
  {
    type: "Fire",
    style: "4 0 7 2",
    species: "Rapidash",
    set: "3",
    nature: "Modest",
    item: "White Herb",
    move1: "Overheat",
    move2: "SolarBeam",
    move3: "Sunny Day",
    move4: "Hypnosis",
    abilities: "Run Away / Flash Fire",
    evs: "170/ 0 / 0 /170/ 0 /170",
    speed: "146",
  },
  {
    type: "Fire",
    style: "4 4 0 0",
    species: "Rapidash",
    set: "4",
    nature: "Docile",
    item: "White Herb",
    move1: "Overheat",
    move2: "Double-Edge",
    move3: "Iron Tail",
    move4: "Double Kick",
    abilities: "Run Away / Flash Fire",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "146",
  },
  {
    type: "Ice",
    style: "0 0 1 3",
    species: "Regice",
    set: "1",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Ice Beam",
    move2: "Thunderbolt",
    move3: "Amnesia",
    move4: "Rest",
    abilities: "Clear Body",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "70",
  },
  {
    type: "Ice",
    style: "0 7 0 0",
    species: "Regice",
    set: "2",
    nature: "Quiet",
    item: "Bright Powder",
    move1: "Thunder",
    move2: "Rain Dance",
    move3: "Blizzard",
    move4: "Brick Break",
    abilities: "Clear Body",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "63",
  },
  {
    type: "Ice",
    style: "0 0 2 4",
    species: "Regice",
    set: "3",
    nature: "Quiet",
    item: "Lum Berry",
    move1: "Ice Beam",
    move2: "Thunderbolt",
    move3: "Thunder Wave",
    move4: "Explosion",
    abilities: "Clear Body",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "63",
  },
  {
    type: "Ice",
    style: "0 7 1 2",
    species: "Regice",
    set: "4",
    nature: "Bold",
    item: "Leftovers",
    move1: "Ice Beam",
    move2: "Hail",
    move3: "Double Team",
    move4: "Thunder Wave",
    abilities: "Clear Body",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Ice",
    style: "0 0 6 4",
    species: "Regice",
    set: "5",
    nature: "Brave",
    item: "Leftovers",
    move1: "Earthquake",
    move2: "Ice Beam",
    move3: "Curse",
    move4: "Counter",
    abilities: "Clear Body",
    evs: "170/ 0 /170/170/ 0 / 0 ",
    speed: "63",
  },
  {
    type: "Ice",
    style: "0 0 0 3",
    species: "Regice",
    set: "6",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Ice Beam",
    move2: "Thunderbolt",
    move3: "Sleep Talk",
    move4: "Rest",
    abilities: "Clear Body",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "70",
  },
  {
    type: "Rock",
    style: "0 0 0 4",
    species: "Regirock",
    set: "1",
    nature: "Adamant",
    item: "White Herb",
    move1: "Superpower",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Explosion",
    abilities: "Clear Body",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Rock",
    style: "0 0 4 4",
    species: "Regirock",
    set: "2",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Counter",
    move4: "Explosion",
    abilities: "Clear Body",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Rock",
    style: "0 0 6 3",
    species: "Regirock",
    set: "3",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Rock Slide",
    move2: "Earthquake",
    move3: "Curse",
    move4: "Rest",
    abilities: "Clear Body",
    evs: "255/ 0 / 0 / 0 /255/ 0 ",
    speed: "70",
  },
  {
    type: "Rock",
    style: "0 0 1 2",
    species: "Regirock",
    set: "4",
    nature: "Careful",
    item: "Leftovers",
    move1: "Rock Slide",
    move2: "Brick Break",
    move3: "Double Team",
    move4: "Thunder Wave",
    abilities: "Clear Body",
    evs: "170/170/ 0 / 0 /170/ 0 ",
    speed: "70",
  },
  {
    type: "Rock",
    style: "4 4 0 1",
    species: "Regirock",
    set: "5",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Hyper Beam",
    move2: "Focus Punch",
    move3: "Rock Slide",
    move4: "Double Team",
    abilities: "Clear Body",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Rock",
    style: "2 1 0 4",
    species: "Regirock",
    set: "6",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Swagger",
    move2: "Psych Up",
    move3: "Rock Slide",
    move4: "Explosion",
    abilities: "Clear Body",
    evs: "255/ 0 / 0 / 0 /255/ 0 ",
    speed: "70",
  },
  {
    type: "Steel",
    style: "0 6 1 3",
    species: "Registeel",
    set: "1",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Metal Claw",
    move2: "Curse",
    move3: "Amnesia",
    move4: "Rest",
    abilities: "Clear Body",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Steel",
    style: "0 0 0 0",
    species: "Registeel",
    set: "2",
    nature: "Quiet",
    item: "Bright Powder",
    move1: "Thunderbolt",
    move2: "Ice Punch",
    move3: "Earthquake",
    move4: "Aerial Ace",
    abilities: "Clear Body",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "63",
  },
  {
    type: "Steel",
    style: "0 0 4 4",
    species: "Registeel",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Ancient Power",
    move2: "Amnesia",
    move3: "Counter",
    move4: "Explosion",
    abilities: "Clear Body",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "70",
  },
  {
    type: "Steel",
    style: "0 0 1 2",
    species: "Registeel",
    set: "4",
    nature: "Impish",
    item: "Leftovers",
    move1: "Ancient Power",
    move2: "Earthquake",
    move3: "Double Team",
    move4: "Thunder Wave",
    abilities: "Clear Body",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "70",
  },
  {
    type: "Steel",
    style: "4 6 2 1",
    species: "Registeel",
    set: "5",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Focus Punch",
    move2: "Substitute",
    move3: "Toxic",
    move4: "Double Team",
    abilities: "Clear Body",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "70",
  },
  {
    type: "Steel",
    style: "0 0 2 1",
    species: "Registeel",
    set: "6",
    nature: "Adamant",
    item: "White Herb",
    move1: "Superpower",
    move2: "Aerial Ace",
    move3: "Swagger",
    move4: "Psych Up",
    abilities: "Clear Body",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "70",
  },
  {
    type: "Ground Rock",
    style: "0 0 5 0",
    species: "Rhydon",
    set: "1",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Earthquake",
    move2: "Rock Tomb",
    move3: "Scary Face",
    move4: "Brick Break",
    abilities: "Lightningrod / Rock Head",
    evs: "170/170/ 0 / 0 /170/ 0 ",
    speed: "60",
  },
  {
    type: "Ground Rock",
    style: "0 4 0 0",
    species: "Rhydon",
    set: "2",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Earthquake",
    move2: "Horn Drill",
    move3: "Rock Slide",
    move4: "Brick Break",
    abilities: "Lightningrod / Rock Head",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "60",
  },
  {
    type: "Ground Rock",
    style: "0 0 0 4",
    species: "Rhydon",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Megahorn",
    move2: "Crush Claw",
    move3: "Earthquake",
    move4: "Horn Drill",
    abilities: "Lightningrod / Rock Head",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "60",
  },
  {
    type: "Ground Rock",
    style: "0 0 0 4",
    species: "Rhydon",
    set: "4",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Megahorn",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Horn Drill",
    abilities: "Lightningrod / Rock Head",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "60",
  },
  {
    type: "Dragon Flying",
    style: "0 0 0 0",
    species: "Salamence",
    set: "1",
    nature: "Hardy",
    item: "King's Rock",
    move1: "Dragon Claw",
    move2: "Aerial Ace",
    move3: "Headbutt",
    move4: "Rock Slide",
    abilities: "Intimidate",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Dragon Flying",
    style: "4 0 2 3",
    species: "Salamence",
    set: "2",
    nature: "Hardy",
    item: "Leftovers",
    move1: "Double-Edge",
    move2: "Crunch",
    move3: "Swagger",
    move4: "Protect",
    abilities: "Intimidate",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "141",
  },
  {
    type: "Dragon Flying",
    style: "4 0 0 3 ",
    species: "Salamence",
    set: "3",
    nature: "Hardy",
    item: "Salac Berry",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Crunch",
    move4: "Endure",
    abilities: "Intimidate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "120",
  },
  {
    type: "Dragon Flying",
    style: "4 0 0 1",
    species: "Salamence",
    set: "4",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Aerial Ace",
    move4: "Dragon Dance",
    abilities: "Intimidate",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "120",
  },
  {
    type: "Dragon Flying",
    style: "4 0 0 1",
    species: "Salamence",
    set: "5",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Facade",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Dragon Dance",
    abilities: "Intimidate",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "120",
  },
  {
    type: "Dragon Flying",
    style: "0 0 0 1",
    species: "Salamence",
    set: "6",
    nature: "Hardy",
    item: "Lum Berry",
    move1: "Headbutt",
    move2: "Aerial Ace",
    move3: "Crunch",
    move4: "Dragon Dance",
    abilities: "Intimidate",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "120",
  },
  {
    type: "Dragon Flying",
    style: "0 0 0 0",
    species: "Salamence",
    set: "7",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Flamethrower",
    move2: "Dragon Claw",
    move3: "Crunch",
    move4: "Brick Break",
    abilities: "Intimidate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Dragon Flying",
    style: "0 0 0 2",
    species: "Salamence",
    set: "8",
    nature: "Modest",
    item: "Leftovers",
    move1: "Flamethrower",
    move2: "Dragon Claw",
    move3: "Crunch",
    move4: "Attract",
    abilities: "Intimidate",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Grass",
    style: "0 2 0 3",
    species: "Sceptile",
    set: "1",
    nature: "Modest",
    item: "Leftovers",
    move1: "Leaf Blade",
    move2: "Leech Seed",
    move3: "Aerial Ace",
    move4: "Detect",
    abilities: "Overgrow",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "172",
  },
  {
    type: "Grass",
    style: "0 0 2 1",
    species: "Sceptile",
    set: "2",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Leaf Blade",
    move2: "Thunder Punch",
    move3: "Attract",
    move4: "Double Team",
    abilities: "Overgrow",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "172",
  },
  {
    type: "Grass",
    style: "0 0 0 0",
    species: "Sceptile",
    set: "3",
    nature: "Docile",
    item: "Scope Lens",
    move1: "Leaf Blade",
    move2: "Earthquake",
    move3: "Crush Claw",
    move4: "Aerial Ace",
    abilities: "Overgrow",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "161",
  },
  {
    type: "Grass",
    style: "0 0 0 0",
    species: "Sceptile",
    set: "4",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Leaf Blade",
    move2: "Dragon Claw",
    move3: "Crunch",
    move4: "Thunder Punch",
    abilities: "Overgrow",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "172",
  },
  {
    type: "Bug Steel",
    style: "0 0 4 0",
    species: "Scizor",
    set: "1",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Metal Claw",
    move2: "Aerial Ace",
    move3: "Counter",
    move4: "Quick Attack",
    abilities: "Swarm",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "85",
  },
  {
    type: "Bug Steel",
    style: "0 0 1 3",
    species: "Scizor",
    set: "2",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Silver Wind",
    move2: "Steel Wing",
    move3: "Swords Dance",
    move4: "Light Screen",
    abilities: "Swarm",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "85",
  },
  {
    type: "Bug Steel",
    style: "4 3 1 0",
    species: "Scizor",
    set: "3",
    nature: "Careful",
    item: "Focus Band",
    move1: "Reversal",
    move2: "Endure",
    move3: "Agility",
    move4: "Slash",
    abilities: "Swarm",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "85",
  },
  {
    type: "Bug Steel",
    style: "0 1 1 3",
    species: "Scizor",
    set: "4",
    nature: "Careful",
    item: "Bright Powder",
    move1: "Silver Wind",
    move2: "Swords Dance",
    move3: "Agility",
    move4: "Baton Pass",
    abilities: "Swarm",
    evs: "255/ 0 / 0 / 0 /255/ 0 ",
    speed: "85",
  },
  {
    type: "Dark Grass",
    style: "0 0 0 0",
    species: "Shiftry",
    set: "1",
    nature: "Quiet",
    item: "Miracle Seed",
    move1: "Giga Drain",
    move2: "Faint Attack",
    move3: "Quick Attack",
    move4: "Fake Out",
    abilities: "Chlorophyll / Early Bird",
    evs: " 0 / 0 /170/170/170/ 0 ",
    speed: "90",
  },
  {
    type: "Dark Grass",
    style: "2 0 1 3",
    species: "Shiftry",
    set: "2",
    nature: "Impish",
    item: "Chesto Berry",
    move1: "Leech Seed",
    move2: "Dig",
    move3: "Double Team",
    move4: "Rest",
    abilities: "Chlorophyll / Early Bird",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "100",
  },
  {
    type: "Dark Grass",
    style: "0 7 4 3",
    species: "Shiftry",
    set: "3",
    nature: "Quirky",
    item: "Focus Band",
    move1: "SolarBeam",
    move2: "Sunny Day",
    move3: "Explosion",
    move4: "Synthesis",
    abilities: "Chlorophyll / Early Bird",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Dark Grass",
    style: "4 0 0 0",
    species: "Shiftry",
    set: "4",
    nature: "Hardy",
    item: "Focus Band",
    move1: "Explosion",
    move2: "Giga Drain",
    move3: "Mega Kick",
    move4: "Fake Out",
    abilities: "Chlorophyll / Early Bird",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "100",
  },
  {
    type: "Bug Rock",
    style: "0 1 0 3",
    species: "Shuckle",
    set: "1",
    nature: "Brave",
    item: "Chesto Berry",
    move1: "Rollout",
    move2: "Defense Curl",
    move3: "Sleep Talk",
    move4: "Rest",
    abilities: "Sturdy",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "22",
  },
  {
    type: "Bug Rock",
    style: "7 0 5 1",
    species: "Shuckle",
    set: "2",
    nature: "Careful",
    item: "Leftovers",
    move1: "Sandstorm",
    move2: "Dig",
    move3: "Flash",
    move4: "Double Team",
    abilities: "Sturdy",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "25",
  },
  {
    type: "Bug Rock",
    style: "6 2 2 1",
    species: "Shuckle",
    set: "3",
    nature: "Careful",
    item: "Leftovers",
    move1: "Substitute",
    move2: "Attract",
    move3: "Toxic",
    move4: "Double Team",
    abilities: "Sturdy",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "25",
  },
  {
    type: "Bug Rock",
    style: "2 1 0 3",
    species: "Shuckle",
    set: "4",
    nature: "Careful",
    item: "Chesto Berry",
    move1: "Toxic",
    move2: "Double Team",
    move3: "Wrap",
    move4: "Rest",
    abilities: "Sturdy",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "25",
  },
  {
    type: "Flying Steel",
    style: "0 0 4 1",
    species: "Skarmory",
    set: "1",
    nature: "Adamant",
    item: "Scope Lens",
    move1: "Steel Wing",
    move2: "Air Cutter",
    move3: "Counter",
    move4: "Agility",
    abilities: "Keen Eye / Sturdy",
    evs: "170/170/ 0 / 0 /170/ 0 ",
    speed: "90",
  },
  {
    type: "Flying Steel",
    style: "2 0 0 2",
    species: "Skarmory",
    set: "2",
    nature: "Careful",
    item: "Bright Powder",
    move1: "Spikes",
    move2: "Roar",
    move3: "Drill Peck",
    move4: "Toxic",
    abilities: "Keen Eye / Sturdy",
    evs: "170/170/ 0 / 0 /170/ 0 ",
    speed: "90",
  },
  {
    type: "Flying Steel ",
    style: "2 6 3 0",
    species: "Skarmory",
    set: "3",
    nature: "Careful",
    item: "Chesto Berry",
    move1: "Toxic",
    move2: "Curse",
    move3: "Rest",
    move4: "Fly",
    abilities: "Keen Eye / Sturdy",
    evs: "255/ 0 / 0 / 0 /255/ 0 ",
    speed: "90",
  },
  {
    type: "Flying Steel",
    style: "0 0 4 0",
    species: "Skarmory",
    set: "4",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Drill Peck",
    move2: "Steel Wing",
    move3: "Counter",
    move4: "Rock Slide",
    abilities: "Keen Eye / Sturdy",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "90",
  },
  {
    type: "Normal",
    style: "2 1 2 0",
    species: "Slaking",
    set: "1",
    nature: "Adamant",
    item: "Scope Lens",
    move1: "Yawn",
    move2: "Bulk Up",
    move3: "Swagger",
    move4: "Aerial Ace",
    abilities: "Truant",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "120",
  },
  {
    type: "Normal",
    style: "0 0 2 1",
    species: "Slaking",
    set: "2",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Mega Kick",
    move2: "Shadow Ball",
    move3: "Yawn",
    move4: "Amnesia",
    abilities: "Truant",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "120",
  },
  {
    type: "Normal",
    style: "0 0 0 0",
    species: "Slaking",
    set: "3",
    nature: "Adamant",
    item: "Choice Band",
    move1: "Earthquake",
    move2: "Shadow Ball",
    move3: "Aerial Ace",
    move4: "Brick Break",
    abilities: "Truant",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "120",
  },
  {
    type: "Normal",
    style: "0 0 0 2",
    species: "Slaking",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Thunderbolt",
    move2: "Flamethrower",
    move3: "Ice Beam",
    move4: "Yawn",
    abilities: "Truant",
    evs: " 0 / 0 / 0 /255/255/ 0 ",
    speed: "120",
  },
  {
    type: "Psychic Water",
    style: "0 7 0 0",
    species: "Slowbro",
    set: "1",
    nature: "Quiet",
    item: "Shell Bell",
    move1: "Surf",
    move2: "Rain Dance",
    move3: "Headbutt",
    move4: "Ice Punch",
    abilities: "Oblivious / Own Tempo",
    evs: "255/ 0 / 0 / 0 /255/ 0 ",
    speed: "45",
  },
  {
    type: "Psychic Water",
    style: "0 0 1 2",
    species: "Slowbro",
    set: "2",
    nature: "Modest",
    item: "Leftovers",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Calm Mind",
    move4: "Yawn",
    abilities: "Oblivious / Own Tempo",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "50",
  },
  {
    type: "Psychic Water",
    style: "0 0 0 2",
    species: "Slowbro",
    set: "3",
    nature: "Quiet",
    item: "Quick Claw",
    move1: "Surf",
    move2: "Psychic",
    move3: "Shadow Ball",
    move4: "Attract",
    abilities: "Oblivious / Own Tempo",
    evs: " 0 / 0 / 0 /255/255/ 0 ",
    speed: "45",
  },
  {
    type: "Psychic Water",
    style: "0 0 0 0",
    species: "Slowbro",
    set: "4",
    nature: "Sassy",
    item: "Quick Claw",
    move1: "Psychic",
    move2: "Surf",
    move3: "Earthquake",
    move4: "Ice Beam",
    abilities: "Oblivious / Own Tempo",
    evs: " 0 / 0 / 0 /255/255/ 0 ",
    speed: "45",
  },
  {
    type: "Psychic Water",
    style: "0 0 1 2",
    species: "Slowking",
    set: "1",
    nature: "Quiet",
    item: "Leftovers",
    move1: "Psychic",
    move2: "Brick Break",
    move3: "Amnesia",
    move4: "Attract",
    abilities: "Oblivious / Own Tempo",
    evs: "255/ 0 /255/ 0 / 0 / 0 ",
    speed: "45",
  },
  {
    type: "Psychic Water",
    style: "2 2 0 0",
    species: "Slowking",
    set: "2",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Yawn",
    move2: "Thunder Wave",
    move3: "Surf",
    move4: "Psychic",
    abilities: "Oblivious / Own Tempo",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "50",
  },
  {
    type: "Psychic Water",
    style: "0 0 0 0",
    species: "Slowking",
    set: "3",
    nature: "Quiet",
    item: "Quick Claw",
    move1: "Psychic",
    move2: "Surf",
    move3: "Ice Beam",
    move4: "Earthquake",
    abilities: "Oblivious / Own Tempo",
    evs: " 0 /170/170/170/ 0 / 0 ",
    speed: "45",
  },
  {
    type: "Psychic Water",
    style: "0 0 0 0",
    species: "Slowking",
    set: "4",
    nature: "Modest",
    item: "Quick Claw",
    move1: "Psychic",
    move2: "Surf",
    move3: "Ice Beam",
    move4: "Flamethrower",
    abilities: "Oblivious / Own Tempo",
    evs: " 0 / 0 /255/255/ 0 / 0 ",
    speed: "50",
  },
  {
    type: "Normal",
    style: "4 0 2 1",
    species: "Snorlax",
    set: "1",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Facade",
    move2: "Shadow Ball",
    move3: "Attract",
    move4: "Double Team",
    abilities: "Immunity / Thick Fat",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "50",
  },
  {
    type: "Normal",
    style: "0 0 6 3",
    species: "Snorlax",
    set: "2",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Curse",
    move4: "Rest",
    abilities: "Immunity / Thick Fat",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "50",
  },
  {
    type: "Normal",
    style: "0 0 2 1",
    species: "Snorlax",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Mega Kick",
    move2: "Shadow Ball",
    move3: "Swagger",
    move4: "Psych Up",
    abilities: "Immunity / Thick Fat",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "50",
  },
  {
    type: "Normal",
    style: "4 0 0 6",
    species: "Snorlax",
    set: "4",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Double-Edge",
    move2: "Shadow Ball",
    move3: "Brick Break",
    move4: "Curse",
    abilities: "Immunity / Thick Fat",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "50",
  },
  {
    type: "Normal",
    style: "0 0 0 4",
    species: "Snorlax",
    set: "5",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Mega Kick",
    move2: "Shadow Ball",
    move3: "Brick Break",
    move4: "Counter",
    abilities: "Immunity / Thick Fat",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "50",
  },
  {
    type: "Normal",
    style: "0 0 0 4",
    species: "Snorlax",
    set: "6",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Earthquake",
    move2: "Shadow Ball",
    move3: "Brick Break",
    move4: "Counter",
    abilities: "Immunity / Thick Fat",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "50",
  },
  {
    type: "Normal",
    style: "4 0 0 6",
    species: "Snorlax",
    set: "7",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Hyper Beam",
    move2: "Shadow Ball",
    move3: "Earthquake",
    move4: "Curse",
    abilities: "Immunity / Thick Fat",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "50",
  },
  {
    type: "Normal",
    style: "0 0 1 3",
    species: "Snorlax",
    set: "8",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Return",
    move2: "Shadow Ball",
    move3: "Belly Drum",
    move4: "Rest",
    abilities: "Immunity / Thick Fat",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "50",
  },
  {
    type: "Psychic Water",
    style: "0 2 2 3",
    species: "Starmie",
    set: "1",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Psychic",
    move2: "Confuse Ray",
    move3: "Thunder Wave",
    move4: "Recover",
    abilities: "Illuminate / Natural Cure",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "135",
  },
  {
    type: "Psychic Water",
    style: "0 0 7 3",
    species: "Starmie",
    set: "2",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Hydro Pump",
    move2: "Thunder",
    move3: "Rain Dance",
    move4: "Recover",
    abilities: "Illuminate / Natural Cure",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "135",
  },
  {
    type: "Psychic Water",
    style: "0 0 0 0",
    species: "Starmie",
    set: "3",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Surf",
    move2: "Psychic",
    move3: "Thunderbolt",
    move4: "Ice Beam",
    abilities: "Illuminate / Natural Cure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Psychic Water",
    style: "0 0 0 3",
    species: "Starmie",
    set: "4",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Psychic",
    move2: "Thunderbolt",
    move3: "Ice Beam",
    move4: "Recover",
    abilities: "Illuminate / Natural Cure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Psychic Water",
    style: "0 0 3 3",
    species: "Starmie",
    set: "5",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Surf",
    move2: "Psychic",
    move3: "Recover",
    move4: "Light Screen",
    abilities: "Illuminate / Natural Cure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Psychic Water",
    style: "0 2 2 3",
    species: "Starmie",
    set: "6",
    nature: "Calm",
    item: "Leftovers",
    move1: "Surf",
    move2: "Confuse Ray",
    move3: "Thunder Wave",
    move4: "Recover",
    abilities: "Illuminate / Natural Cure",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "135",
  },
  {
    type: "Psychic Water",
    style: "0 0 1 3",
    species: "Starmie",
    set: "7",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Psychic",
    move2: "Ice Beam",
    move3: "Cosmic Power",
    move4: "Recover",
    abilities: "Illuminate / Natural Cure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Psychic Water",
    style: "0 0 1 3",
    species: "Starmie",
    set: "8",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Surf",
    move2: "Thunderbolt",
    move3: "Cosmic Power",
    move4: "Recover",
    abilities: "Illuminate / Natural Cure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "167",
  },
  {
    type: "Ground Steel",
    style: "0 0 0 0",
    species: "Steelix",
    set: "1",
    nature: "Adamant",
    item: "Sitrus Berry",
    move1: "Earthquake",
    move2: "Dragon Breath",
    move3: "Rock Tomb",
    move4: "Roar",
    abilities: "Rock Head / Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "50",
  },
  {
    type: "Ground Steel",
    style: "0 0 7 2",
    species: "Steelix",
    set: "2",
    nature: "Hardy",
    item: "Leftovers",
    move1: "Earthquake",
    move2: "Dragon Breath",
    move3: "Sandstorm",
    move4: "Block",
    abilities: "Rock Head / Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "50",
  },
  {
    type: "Ground Steel",
    style: "0 0 0 4",
    species: "Steelix",
    set: "3",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Earthquake",
    move2: "Body Slam",
    move3: "Rock Slide",
    move4: "Explosion",
    abilities: "Rock Head / Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "50",
  },
  {
    type: "Ground Steel",
    style: "0 0 4 4",
    species: "Steelix",
    set: "4",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Earthquake",
    move2: "Iron Tail",
    move3: "Double-Edge",
    move4: "Explosion",
    abilities: "Rock Head / Sturdy",
    evs: " 0 /255/ 0 / 0 /255/ 0 ",
    speed: "50",
  },
  {
    type: "Water",
    style: "0 1 1 3",
    species: "Suicune",
    set: "1",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Surf",
    move2: "Double Team",
    move3: "Calm Mind",
    move4: "Rest",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "137",
  },
  {
    type: "Water",
    style: "2 0 1 3",
    species: "Suicune",
    set: "2",
    nature: "Calm",
    item: "Leftovers",
    move1: "Toxic",
    move2: "Dive",
    move3: "Double Team",
    move4: "Protect",
    abilities: "Pressure",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "105",
  },
  {
    type: "Water",
    style: "0 0 7 0",
    species: "Suicune",
    set: "3",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Rain Dance",
    move4: "Roar",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "137",
  },
  {
    type: "Water",
    style: "0 0 0 3",
    species: "Suicune",
    set: "4",
    nature: "Modest",
    item: "Bright Powder",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Bite",
    move4: "Reflect",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "137",
  },
  {
    type: "Water",
    style: "0 0 1 0",
    species: "Suicune",
    set: "5",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Calm Mind",
    move4: "Icy Wind",
    abilities: "Pressure",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "105",
  },
  {
    type: "Water",
    style: "0 0 1 3",
    species: "Suicune",
    set: "6",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Calm Mind",
    move4: "Rest",
    abilities: "Pressure",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "105",
  },
  {
    type: "Ground Water",
    style: "0 4 3 6",
    species: "Swampert",
    set: "1",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Earthquake",
    move2: "Counter",
    move3: "Rest",
    move4: "Curse",
    abilities: "Torrent",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "80",
  },
  {
    type: "Ground Water",
    style: "0 0 4 4",
    species: "Swampert",
    set: "2",
    nature: "Docile",
    item: "Quick Claw",
    move1: "Surf",
    move2: "Earthquake",
    move3: "Counter",
    move4: "Mirror Coat",
    abilities: "Torrent",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "80",
  },
  {
    type: "Ground Water",
    style: "0 0 0 4",
    species: "Swampert",
    set: "3",
    nature: "Brave",
    item: "Shell Bell",
    move1: "Surf",
    move2: "Earthquake",
    move3: "Ice Beam",
    move4: "Counter",
    abilities: "Torrent",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "72",
  },
  {
    type: "Ground Water",
    style: "0 0 0 4",
    species: "Swampert",
    set: "4",
    nature: "Quiet",
    item: "Shell Bell",
    move1: "Surf",
    move2: "Earthquake",
    move3: "Ice Beam",
    move4: "Mirror Coat",
    abilities: "Torrent",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "72",
  },
  {
    type: "Normal",
    style: "0 0 2 4",
    species: "Tauros",
    set: "1",
    nature: "Adamant",
    item: "Persim Berry",
    move1: "Earthquake",
    move2: "Thrash",
    move3: "Swagger",
    move4: "Facade",
    abilities: "Intimidate",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "162",
  },
  {
    type: "Normal",
    style: "4 0 1 3",
    species: "Tauros",
    set: "2",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Double Team",
    move4: "Rest",
    abilities: "Intimidate",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "130",
  },
  {
    type: "Normal",
    style: "4 0 0 0",
    species: "Tauros",
    set: "3",
    nature: "Docile",
    item: "Leftovers",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Flamethrower",
    move4: "Ice Beam",
    abilities: "Intimidate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Normal",
    style: "4 0 0 0",
    species: "Tauros",
    set: "4",
    nature: "Docile",
    item: "Bright Powder",
    move1: "Double-Edge",
    move2: "Rock Tomb",
    move3: "Thunderbolt",
    move4: "Surf",
    abilities: "Intimidate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "130",
  },
  {
    type: "Poison Water",
    style: "0 0 1 2",
    species: "Tentacruel",
    set: "1",
    nature: "Impish",
    item: "Persim Berry",
    move1: "Sludge Bomb",
    move2: "Icy Wind",
    move3: "Barrier",
    move4: "Confuse Ray",
    abilities: "Clear Body / Liquid Ooze",
    evs: " 0 /255/255/ 0 / 0 / 0 ",
    speed: "120",
  },
  {
    type: "Poison Water",
    style: "2 0 2 0",
    species: "Tentacruel",
    set: "2",
    nature: "Hardy",
    item: "Leftovers",
    move1: "Toxic",
    move2: "Giga Drain",
    move3: "Confuse Ray",
    move4: "Surf",
    abilities: "Clear Body / Liquid Ooze",
    evs: "170/ 0 /170/170/ 0 / 0 ",
    speed: "120",
  },
  {
    type: "Poison Water",
    style: "0 0 0 4",
    species: "Tentacruel",
    set: "3",
    nature: "Modest",
    item: "Shell Bell",
    move1: "Surf",
    move2: "Giga Drain",
    move3: "Ice Beam",
    move4: "Mirror Coat",
    abilities: "Clear Body / Liquid Ooze",
    evs: " 0 / 0 /170/170/ 0 /170",
    speed: "141",
  },
  {
    type: "Poison Water",
    style: "0 0 0 4",
    species: "Tentacruel",
    set: "4",
    nature: "Quirky",
    item: "Shell Bell",
    move1: "Hydro Pump",
    move2: "Sludge Bomb",
    move3: "Ice Beam",
    move4: "Mirror Coat",
    abilities: "Clear Body / Liquid Ooze",
    evs: " 0 /170/170/170/ 0 / 0 ",
    speed: "120",
  },
  {
    type: "Fire",
    style: "0 7 5 0",
    species: "Typhlosion",
    set: "1",
    nature: "Modest",
    item: "Focus Band",
    move1: "Fire Blast",
    move2: "Sunny Day",
    move3: "SmokeScreen",
    move4: "Roar",
    abilities: "Blaze",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Fire",
    style: "0 0 0 0",
    species: "Typhlosion",
    set: "2",
    nature: "Hardy",
    item: "Scope Lens",
    move1: "Flamethrower",
    move2: "Thunder Punch",
    move3: "Aerial Ace",
    move4: "Rock Slide",
    abilities: "Blaze",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "141",
  },
  {
    type: "Fire",
    style: "0 4 3 4",
    species: "Typhlosion",
    set: "3",
    nature: "Adamant",
    item: "Salac Berry",
    move1: "Earthquake",
    move2: "Overheat",
    move3: "Endure",
    move4: "Reversal",
    abilities: "Blaze",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Fire",
    style: "4 0 0 0",
    species: "Typhlosion",
    set: "4",
    nature: "Hardy",
    item: "White Herb",
    move1: "Overheat",
    move2: "Thunder Punch",
    move3: "Earthquake",
    move4: "Crush Claw",
    abilities: "Blaze",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "141",
  },
  {
    type: "Dark Rock",
    style: "0 0 0 0",
    species: "Tyranitar",
    set: "1",
    nature: "Hardy",
    item: "Bright Powder",
    move1: "Earthquake",
    move2: "Aerial Ace",
    move3: "Thunderbolt",
    move4: "Surf",
    abilities: "Sand Stream",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "81",
  },
  {
    type: "Dark Rock",
    style: "0 0 0 0",
    species: "Tyranitar",
    set: "2",
    nature: "Hardy",
    item: "Bright Powder",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Crunch",
    move4: "Thunderbolt",
    abilities: "Sand Stream",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "81",
  },
  {
    type: "Dark Rock",
    style: "0 0 4 1",
    species: "Tyranitar",
    set: "3",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Counter",
    move4: "Dragon Dance",
    abilities: "Sand Stream",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "81",
  },
  {
    type: "Dark Rock",
    style: "0 0 0 0 ",
    species: "Tyranitar",
    set: "4",
    nature: "Modest",
    item: "Quick Claw",
    move1: "Crunch",
    move2: "Ice Beam",
    move3: "Thunderbolt",
    move4: "Flamethrower",
    abilities: "Sand Stream",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "81",
  },
  {
    type: "Dark Rock",
    style: "0 0 1 3",
    species: "Tyranitar",
    set: "5",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Dragon Dance",
    move4: "Rest",
    abilities: "Sand Stream",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "81",
  },
  {
    type: "Dark Rock",
    style: "0 0 6 3",
    species: "Tyranitar",
    set: "6",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Curse",
    move4: "Rest",
    abilities: "Sand Stream",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "81",
  },
  {
    type: "Dark Rock",
    style: "0 0 0 6",
    species: "Tyranitar",
    set: "7",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Rock Slide",
    move2: "Aerial Ace",
    move3: "Brick Break",
    move4: "Curse",
    abilities: "Sand Stream",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "81",
  },
  {
    type: "Dark Rock",
    style: "0 2 1 3",
    species: "Tyranitar",
    set: "8",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Rock Slide",
    move2: "Thunder Wave",
    move3: "Dragon Dance",
    move4: "Rest",
    abilities: "Sand Stream",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "81",
  },
  {
    type: "Dark Rock",
    style: "0 0 0 2",
    species: "Tyranitar",
    set: "9",
    nature: "Hardy",
    item: "Quick Claw",
    move1: "Crunch",
    move2: "Earthquake",
    move3: "Aerial Ace",
    move4: "Attract",
    abilities: "Sand Stream",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "81",
  },
  {
    type: "Dark Rock",
    style: "4 0 0 1",
    species: "Tyranitar",
    set: "X",
    nature: "Adamant",
    item: "Lum Berry",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Dragon Dance",
    abilities: "Sand Stream",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "81",
  },
  {
    type: "Dark",
    style: "2 0 1 3",
    species: "Umbreon",
    set: "1",
    nature: "Bold",
    item: "Bright Powder",
    move1: "Confuse Ray",
    move2: "Faint Attack",
    move3: "Double Team",
    move4: "Baton Pass",
    abilities: "Synchronize",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "85",
  },
  {
    type: "Dark",
    style: "6 5 1 4",
    species: "Umbreon",
    set: "2",
    nature: "Adamant",
    item: "Leftovers",
    move1: "Curse",
    move2: "Screech",
    move3: "Double Team",
    move4: "Double-Edge",
    abilities: "Synchronize",
    evs: "170/170/ 0 / 0 /170/ 0 ",
    speed: "85",
  },
  {
    type: "Dark",
    style: "2 1 2 0",
    species: "Umbreon",
    set: "3",
    nature: "Bold",
    item: "Bright Powder",
    move1: "Swagger",
    move2: "Psych Up",
    move3: "Attract",
    move4: "Shadow Ball",
    abilities: "Synchronize",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "85",
  },
  {
    type: "Dark ",
    style: "2 2 0 1",
    species: "Umbreon",
    set: "4",
    nature: "Bold",
    item: "Leftovers",
    move1: "Confuse Ray",
    move2: "Toxic",
    move3: "Faint Attack",
    move4: "Double Team",
    abilities: "Synchronize",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "85",
  },
  {
    type: "Normal",
    style: "0 0 0 4",
    species: "Ursaring",
    set: "1",
    nature: "Docile",
    item: "Quick Claw",
    move1: "Mega Kick",
    move2: "Crunch",
    move3: "Aerial Ace",
    move4: "Counter",
    abilities: "Guts",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "4 0 0 4",
    species: "Ursaring",
    set: "2",
    nature: "Adamant",
    item: "Quick Claw",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Brick Break",
    move4: "Counter",
    abilities: "Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "0 0 0 0",
    species: "Ursaring",
    set: "3",
    nature: "Modest",
    item: "Lum Berry",
    move1: "Fire Punch",
    move2: "Thunder Punch",
    move3: "Ice Punch",
    move4: "Crunch",
    abilities: "Guts",
    evs: "170/ 0 / 0 /170/ 0 /170",
    speed: "96",
  },
  {
    type: "Normal",
    style: "4 0 0 0",
    species: "Ursaring",
    set: "4",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Double-Edge",
    move2: "Earthquake",
    move3: "Rock Slide",
    move4: "Aerial Ace",
    abilities: "Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "0 0 0 0 ",
    species: "Ursaring",
    set: "5",
    nature: "Adamant",
    item: "Choice Band",
    move1: "Mega Kick",
    move2: "Aerial Ace",
    move3: "Rock Slide",
    move4: "Brick Break",
    abilities: "Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "4 2 1 1",
    species: "Ursaring",
    set: "6",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Hyper Beam",
    move2: "Yawn",
    move3: "Swords Dance",
    move4: "Double Team",
    abilities: "Guts",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "4 0 0 1",
    species: "Ursaring",
    set: "7",
    nature: "Docile",
    item: "Quick Claw",
    move1: "Facade",
    move2: "Earthquake",
    move3: "Crunch",
    move4: "Bulk Up",
    abilities: "Guts",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "75",
  },
  {
    type: "Normal",
    style: "4 0 0 0",
    species: "Ursaring",
    set: "8",
    nature: "Docile",
    item: "Quick Claw",
    move1: "Facade",
    move2: "Earthquake",
    move3: "Crunch",
    move4: "Brick Break",
    abilities: "Guts",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "75",
  },
  {
    type: "Water",
    style: "0 0 0 0",
    species: "Vaporeon",
    set: "1",
    nature: "Modest",
    item: "Mystic Water",
    move1: "Surf",
    move2: "Roar",
    move3: "Bite",
    move4: "Quick Attack",
    abilities: "Water Absorb",
    evs: " 0 / 0 /170/170/170/ 0 ",
    speed: "85",
  },
  {
    type: "Water",
    style: "0 0 0 0",
    species: "Vaporeon",
    set: "2",
    nature: "Docile",
    item: "Shell Bell",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Body Slam",
    move4: "Shadow Ball",
    abilities: "Water Absorb",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "85",
  },
  {
    type: "Water",
    style: "0 0 1 3",
    species: "Vaporeon",
    set: "3",
    nature: "Calm",
    item: "Quick Claw",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Acid Armor",
    move4: "Baton Pass",
    abilities: "Water Absorb",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "85",
  },
  {
    type: "Water",
    style: "0 0 1 3",
    species: "Vaporeon",
    set: "4",
    nature: "Calm",
    item: "Lum Berry",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Acid Armor",
    move4: "Rest",
    abilities: "Water Absorb",
    evs: "170/ 0 / 0 /170/170/ 0 ",
    speed: "85",
  },
  {
    type: "Grass Poison",
    style: "0 7 3 2",
    species: "Venusaur",
    set: "1",
    nature: "Quiet",
    item: "Chesto Berry",
    move1: "Giga Drain",
    move2: "Sunny Day",
    move3: "Synthesis",
    move4: "Sleep Powder",
    abilities: "Overgrow",
    evs: "255/ 0 / 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Grass Poison",
    style: "2 0 1 3",
    species: "Venusaur",
    set: "2",
    nature: "Bold",
    item: "Bright Powder",
    move1: "Leech Seed",
    move2: "Giga Drain",
    move3: "Double Team",
    move4: "Light Screen",
    abilities: "Overgrow",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "100",
  },
  {
    type: "Grass Poison",
    style: "4 0 0 2",
    species: "Venusaur",
    set: "3",
    nature: "Adamant",
    item: "Scope Lens",
    move1: "Double-Edge",
    move2: "Sludge Bomb",
    move3: "Earthquake",
    move4: "Sleep Powder",
    abilities: "Overgrow",
    evs: " 0 /170/170/ 0 /170/ 0 ",
    speed: "100",
  },
  {
    type: "Grass Poison",
    style: "0 0 7 0",
    species: "Venusaur",
    set: "4",
    nature: "Docile",
    item: "Lum Berry",
    move1: "SolarBeam",
    move2: "Sludge Bomb",
    move3: "Sunny Day",
    move4: "Earthquake",
    abilities: "Overgrow",
    evs: " 0 /170/ 0 /170/170/ 0 ",
    speed: "100",
  },
  {
    type: "Grass Poison",
    style: "0 2 5 3",
    species: "Victreebel",
    set: "1",
    nature: "Quiet",
    item: "Sitrus Berry",
    move1: "Giga Drain",
    move2: "Sleep Powder",
    move3: "Sweet Scent",
    move4: "Synthesis",
    abilities: "Chlorophyll",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "81",
  },
  {
    type: "Grass Poison",
    style: "0 0 2 2",
    species: "Victreebel",
    set: "2",
    nature: "Serious",
    item: "Leftovers",
    move1: "Giga Drain",
    move2: "Sludge Bomb",
    move3: "Sleep Powder",
    move4: "Attract",
    abilities: "Chlorophyll",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Grass Poison",
    style: "2 3 0 0",
    species: "Victreebel",
    set: "3",
    nature: "Quirky",
    item: "Bright Powder",
    move1: "Stun Spore",
    move2: "Ingrain",
    move3: "Giga Drain",
    move4: "Sludge Bomb",
    abilities: "Chlorophyll",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Grass Poison",
    style: "0 4 0 3",
    species: "Victreebel",
    set: "4",
    nature: "Quirky",
    item: "Bright Powder",
    move1: "Giga Drain",
    move2: "Double-Edge",
    move3: "Sludge Bomb",
    move4: "Synthesis",
    abilities: "Chlorophyll",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "90",
  },
  {
    type: "Grass Poison",
    style: "0 0 3 3",
    species: "Vileplume",
    set: "1",
    nature: "Impish",
    item: "Persim Berry",
    move1: "Sludge Bomb",
    move2: "Petal Dance",
    move3: "Moonlight",
    move4: "Aromatherapy",
    abilities: "Chlorophyll",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "70",
  },
  {
    type: "Grass Poison",
    style: "3 1 2 0",
    species: "Vileplume",
    set: "2",
    nature: "Bold",
    item: "Bright Powder",
    move1: "Ingrain",
    move2: "Double Team",
    move3: "Toxic",
    move4: "Giga Drain",
    abilities: "Chlorophyll",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "70",
  },
  {
    type: "Grass Poison",
    style: "2 2 0 0",
    species: "Vileplume",
    set: "3",
    nature: "Quirky",
    item: "Leftovers",
    move1: "Attract",
    move2: "Stun Spore",
    move3: "Sludge Bomb",
    move4: "Giga Drain",
    abilities: "Chlorophyll",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "70",
  },
  {
    type: "Grass Poison",
    style: "0 0 7 3",
    species: "Vileplume",
    set: "4",
    nature: "Quiet",
    item: "Quick Claw",
    move1: "SolarBeam",
    move2: "Sludge Bomb",
    move3: "Sunny Day",
    move4: "Synthesis",
    abilities: "Chlorophyll",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "63",
  },
  {
    type: "Water",
    style: "0 0 0 0",
    species: "Wailord",
    set: "1",
    nature: "Sassy",
    item: "Shell Bell",
    move1: "Surf",
    move2: "Icy Wind",
    move3: "Body Slam",
    move4: "Roar",
    abilities: "Water Veil / Oblivious",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "72",
  },
  {
    type: "Water",
    style: "4 3 6 1",
    species: "Wailord",
    set: "2",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Double-Edge",
    move2: "Rest",
    move3: "Curse",
    move4: "Amnesia",
    abilities: "Water Veil / Oblivious",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "80",
  },
  {
    type: "Water",
    style: "0 4 1 3 ",
    species: "Wailord",
    set: "3",
    nature: "Modest",
    item: "Chesto Berry",
    move1: "Hydro Pump",
    move2: "Fissure",
    move3: "Double Team",
    move4: "Rest",
    abilities: "Water Veil / Oblivious",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "80",
  },
  {
    type: "Water",
    style: "0 0 0 4",
    species: "Wailord",
    set: "4",
    nature: "Hardy",
    item: "Quick Claw",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Earthquake",
    move4: "Fissure",
    abilities: "Water Veil / Oblivious",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "80",
  },
  {
    type: "Ice Water",
    style: "0 7 2 3",
    species: "Walrein",
    set: "1",
    nature: "Quiet",
    item: "Leftovers",
    move1: "Blizzard",
    move2: "Hail",
    move3: "Yawn",
    move4: "Protect",
    abilities: "Thick Fat",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "76",
  },
  {
    type: "Ice Water",
    style: "0 0 6 1",
    species: "Walrein",
    set: "2",
    nature: "Quirky",
    item: "Focus Band",
    move1: "Earthquake",
    move2: "Ice Beam",
    move3: "Curse",
    move4: "Double Team",
    abilities: "Thick Fat",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "85",
  },
  {
    type: "Ice Water",
    style: "0 4 0 2",
    species: "Walrein",
    set: "3",
    nature: "Hardy",
    item: "Quick Claw",
    move1: "Sheer Cold",
    move2: "Fissure",
    move3: "Surf",
    move4: "Attract",
    abilities: "Thick Fat",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "85",
  },
  {
    type: "Ice Water",
    style: "0 0 0 0",
    species: "Walrein",
    set: "4",
    nature: "Quiet",
    item: "Bright Powder",
    move1: "Surf",
    move2: "Ice Beam",
    move3: "Earthquake",
    move4: "Sheer Cold",
    abilities: "Thick Fat",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "76",
  },
  {
    type: "Poison",
    style: "0 2 0 5",
    species: "Weezing",
    set: "1",
    nature: "Adamant",
    item: "Bright Powder",
    move1: "Sludge Bomb",
    move2: "Will-O-Wisp",
    move3: "Shadow Ball",
    move4: "SmokeScreen",
    abilities: "Levitate",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "80",
  },
  {
    type: "Poison",
    style: "4 0 4 4",
    species: "Weezing",
    set: "2",
    nature: "Adamant",
    item: "Sitrus Berry",
    move1: "Memento",
    move2: "Sludge Bomb",
    move3: "Facade",
    move4: "Destiny Bond",
    abilities: "Levitate",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "80",
  },
  {
    type: "Poison",
    style: "4 0 0 0",
    species: "Weezing",
    set: "3",
    nature: "Quirky",
    item: "Focus Band",
    move1: "Explosion",
    move2: "Sludge Bomb",
    move3: "Flamethrower",
    move4: "Thunderbolt",
    abilities: "Levitate",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "80",
  },
  {
    type: "Poison",
    style: "4 0 0 0",
    species: "Weezing",
    set: "4",
    nature: "Adamant",
    item: "Focus Band",
    move1: "Explosion",
    move2: "Sludge Bomb",
    move3: "Frustration",
    move4: "Shadow Ball",
    abilities: "Levitate",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "80",
  },
  {
    type: "Ground Water",
    style: "0 0 1 3",
    species: "Whiscash",
    set: "1",
    nature: "Adamant",
    item: "Chesto Berry",
    move1: "Earthquake",
    move2: "Rock Slide",
    move3: "Amnesia",
    move4: "Rest",
    abilities: "Oblivious",
    evs: "255/255/ 0 / 0 / 0 / 0 ",
    speed: "80",
  },
  {
    type: "Ground Water",
    style: "0 0 0 0 ",
    species: "Whiscash",
    set: "2",
    nature: "Hardy",
    item: "Shell Bell",
    move1: "Surf",
    move2: "Earthquake",
    move3: "Spark",
    move4: "Future Sight",
    abilities: "Oblivious",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "80",
  },
  {
    type: "Ground Water",
    style: "0 3 0 4",
    species: "Whiscash",
    set: "3",
    nature: "Hardy",
    item: "Chesto Berry",
    move1: "Sleep Talk",
    move2: "Rest",
    move3: "Surf",
    move4: "Fissure",
    abilities: "Oblivious",
    evs: " 0 / 0 /255/ 0 /255/ 0 ",
    speed: "80",
  },
  {
    type: "Ground Water",
    style: "4 0 0 0",
    species: "Whiscash",
    set: "4",
    nature: "Quiet",
    item: "Quick Claw",
    move1: "Fissure",
    move2: "Surf",
    move3: "Earthquake",
    move4: "Ice Beam",
    abilities: "Oblivious",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "72",
  },
  {
    type: "Flying Psychic",
    style: "0 0 3 0",
    species: "Xatu",
    set: "1",
    nature: "Hardy",
    item: "Sharp Beak",
    move1: "Drill Peck",
    move2: "Night Shade",
    move3: "Wish",
    move4: "Future Sight",
    abilities: "Synchronize / Early Bird",
    evs: "170/170/ 0 /170/ 0 / 0 ",
    speed: "115",
  },
  {
    type: "Flying Psychic",
    style: "0 2 2 2",
    species: "Xatu",
    set: "2",
    nature: "Impish",
    item: "Leftovers",
    move1: "Fly",
    move2: "Toxic",
    move3: "Confuse Ray",
    move4: "Attract",
    abilities: "Synchronize / Early Bird",
    evs: "170/ 0 /170/ 0 /170/ 0 ",
    speed: "115",
  },
  {
    type: "Flying Psychic",
    style: "0 0 0 0",
    species: "Xatu",
    set: "3",
    nature: "Jolly",
    item: "King's Rock",
    move1: "Drill Peck",
    move2: "Psychic",
    move3: "Giga Drain",
    move4: "Steel Wing",
    abilities: "Synchronize / Early Bird",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "150",
  },
  {
    type: "Flying Psychic",
    style: "0 0 0 2",
    species: "Xatu",
    set: "4",
    nature: "Docile",
    item: "Petaya Berry",
    move1: "Psychic",
    move2: "Drill Peck",
    move3: "Shadow Ball",
    move4: "Confuse Ray",
    abilities: "Synchronize / Early Bird",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "115",
  },
  {
    type: "Electric Flying",
    style: "0 0 2 0",
    species: "Zapdos",
    set: "1",
    nature: "Docile",
    item: "Lum Berry",
    move1: "Thunderbolt",
    move2: "Drill Peck",
    move3: "Thunder Wave",
    move4: "Roar",
    abilities: "Pressure",
    evs: " 0 / 0 / 0 /255/ 0 /255",
    speed: "152",
  },
  {
    type: "Electric Flying",
    style: "0 7 0 1",
    species: "Zapdos",
    set: "2",
    nature: "Docile",
    item: "Bright Powder",
    move1: "Thunder",
    move2: "Rain Dance",
    move3: "Drill Peck",
    move4: "Double Team",
    abilities: "Pressure",
    evs: " 0 /255/ 0 / 0 / 0 /255",
    speed: "152",
  },
  {
    type: "Electric Flying",
    style: "0 0 2 6",
    species: "Zapdos",
    set: "3",
    nature: "Docile",
    item: "Leftovers",
    move1: "Thunderbolt",
    move2: "Drill Peck",
    move3: "Thunder Wave",
    move4: "Substitute",
    abilities: "Pressure",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "141",
  },
  {
    type: "Electric Flying",
    style: "0 0 2 3",
    species: "Zapdos",
    set: "4",
    nature: "Docile",
    item: "Shell Bell",
    move1: "Thunderbolt",
    move2: "Drill Peck",
    move3: "Thunder Wave",
    move4: "Light Screen",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "120",
  },
  {
    type: "Electric Flying",
    style: "0 0 3 2",
    species: "Zapdos",
    set: "5",
    nature: "Docile",
    item: "Scope Lens",
    move1: "Thunderbolt",
    move2: "Drill Peck",
    move3: "Double-Edge",
    move4: "Thunder Wave",
    abilities: "Pressure",
    evs: " 0 /255/ 0 /255/ 0 / 0 ",
    speed: "120",
  },
  {
    type: "Electric Flying",
    style: "0 0 7 4",
    species: "Zapdos",
    set: "6",
    nature: "Docile",
    item: "Lum Berry",
    move1: "Thunder",
    move2: "Drill Peck",
    move3: "Rain Dance",
    move4: "Double-Edge",
    abilities: "Pressure",
    evs: " 0 /170/ 0 /170/ 0 /170",
    speed: "141",
  },
];
